//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as ng from 'angular';

export module Gen {

export class Client {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getBudgetVersionDashboardData(): ng.IPromise<BudgetVersionDashboardDTO[]> {
        let url_ = this.baseUrl + "/api/budget-version/dashboard";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBudgetVersionDashboardData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBudgetVersionDashboardData(_response);
            throw _response;
        });
    }

    protected processGetBudgetVersionDashboardData(response: any): ng.IPromise<BudgetVersionDashboardDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BudgetVersionDashboardDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BudgetVersionDashboardDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetVersionsForDate(date: Date): ng.IPromise<BudgetVersionDTO[]> {
        let url_ = this.baseUrl + "/api/budget-version/date/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBudgetVersionsForDate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBudgetVersionsForDate(_response);
            throw _response;
        });
    }

    protected processGetBudgetVersionsForDate(response: any): ng.IPromise<BudgetVersionDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BudgetVersionDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BudgetVersionDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetVersionsForYear(budgetYear: number): ng.IPromise<BudgetVersionDTO[]> {
        let url_ = this.baseUrl + "/api/budget-version/year/{budgetYear}";
        if (budgetYear === undefined || budgetYear === null)
            throw new Error("The parameter 'budgetYear' must be defined.");
        url_ = url_.replace("{budgetYear}", encodeURIComponent("" + budgetYear));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBudgetVersionsForYear(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBudgetVersionsForYear(_response);
            throw _response;
        });
    }

    protected processGetBudgetVersionsForYear(response: any): ng.IPromise<BudgetVersionDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BudgetVersionDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BudgetVersionDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    markBudgetVersionForExport(budgetVersionUId: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/budget-version/{budgetVersionUId}/export";
        if (budgetVersionUId === undefined || budgetVersionUId === null)
            throw new Error("The parameter 'budgetVersionUId' must be defined.");
        url_ = url_.replace("{budgetVersionUId}", encodeURIComponent("" + budgetVersionUId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarkBudgetVersionForExport(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarkBudgetVersionForExport(_response);
            throw _response;
        });
    }

    protected processMarkBudgetVersionForExport(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    unmarkBudgetVersionForExport(budgetVersionUId: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/budget-version/{budgetVersionUId}/remove-export";
        if (budgetVersionUId === undefined || budgetVersionUId === null)
            throw new Error("The parameter 'budgetVersionUId' must be defined.");
        url_ = url_.replace("{budgetVersionUId}", encodeURIComponent("" + budgetVersionUId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUnmarkBudgetVersionForExport(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUnmarkBudgetVersionForExport(_response);
            throw _response;
        });
    }

    protected processUnmarkBudgetVersionForExport(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    isExportingForecasts(): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/budget-version/is-exporting";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsExportingForecasts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsExportingForecasts(_response);
            throw _response;
        });
    }

    protected processIsExportingForecasts(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    getPeriodsConfiguration(): ng.IPromise<PeriodConfigDTO> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPeriodsConfiguration(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPeriodsConfiguration(_response);
            throw _response;
        });
    }

    protected processGetPeriodsConfiguration(response: any): ng.IPromise<PeriodConfigDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeriodConfigDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<PeriodConfigDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePeriodsConfiguration(body: PeriodConfigDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdatePeriodsConfiguration(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdatePeriodsConfiguration(_response);
            throw _response;
        });
    }

    protected processUpdatePeriodsConfiguration(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getRisks(): ng.IPromise<RiskConfigDTOPageableListResult> {
        let url_ = this.baseUrl + "/api/configuration/risks";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetRisks(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetRisks(_response);
            throw _response;
        });
    }

    protected processGetRisks(response: any): ng.IPromise<RiskConfigDTOPageableListResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RiskConfigDTOPageableListResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<RiskConfigDTOPageableListResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRisks(body: RiskConfigDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration/risks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateRisks(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateRisks(_response);
            throw _response;
        });
    }

    protected processCreateRisks(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRisks(body: RiskConfigDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration/risks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateRisks(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateRisks(_response);
            throw _response;
        });
    }

    protected processUpdateRisks(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getBrands(): ng.IPromise<BrandGroupNameDTO[]> {
        let url_ = this.baseUrl + "/api/configuration/brand-group-name";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBrands(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBrands(_response);
            throw _response;
        });
    }

    protected processGetBrands(response: any): ng.IPromise<BrandGroupNameDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrandGroupNameDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrandGroupNameDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBrandsGroupName(body: BrandGroupNameDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration/brand-group-name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateBrandsGroupName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateBrandsGroupName(_response);
            throw _response;
        });
    }

    protected processCreateBrandsGroupName(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBrandsGroupName(body: BrandGroupNameDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration/brand-group-name";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateBrandsGroupName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateBrandsGroupName(_response);
            throw _response;
        });
    }

    protected processUpdateBrandsGroupName(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    removeBrandGroupName(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration/brand-group-name/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemoveBrandGroupName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemoveBrandGroupName(_response);
            throw _response;
        });
    }

    protected processRemoveBrandGroupName(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCountries(): ng.IPromise<CountryDTO[]> {
        let url_ = this.baseUrl + "/api/configuration/country";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCountries(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCountries(_response);
            throw _response;
        });
    }

    protected processGetCountries(response: any): ng.IPromise<CountryDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CountryDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultCountry(): ng.IPromise<CountryDTO> {
        let url_ = this.baseUrl + "/api/configuration/country/default";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetDefaultCountry(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetDefaultCountry(_response);
            throw _response;
        });
    }

    protected processGetDefaultCountry(response: any): ng.IPromise<CountryDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountryDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CountryDTO>(null as any);
    }

    /**
     * @return Success
     */
    getCurrencies(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/configuration/currency";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCurrencies(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCurrencies(_response);
            throw _response;
        });
    }

    protected processGetCurrencies(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    updateUserConfigData(name: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration/user-config-data/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateUserConfigData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateUserConfigData(_response);
            throw _response;
        });
    }

    protected processUpdateUserConfigData(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getUserConfigData(name: string): ng.IPromise<string> {
        let url_ = this.baseUrl + "/api/configuration/user-config-data/{name}";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetUserConfigData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetUserConfigData(_response);
            throw _response;
        });
    }

    protected processGetUserConfigData(response: any): ng.IPromise<string> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @param source (optional) 
     * @return Success
     */
    getCorrectionPrompts(searchString: string | undefined, source: SourceEnum | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/configuration/correction-prompt?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "Source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCorrectionPrompts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCorrectionPrompts(_response);
            throw _response;
        });
    }

    protected processGetCorrectionPrompts(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getMarketBrands(): ng.IPromise<MarketBrandDTO[]> {
        let url_ = this.baseUrl + "/api/configuration/market-brand";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMarketBrands(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMarketBrands(_response);
            throw _response;
        });
    }

    protected processGetMarketBrands(response: any): ng.IPromise<MarketBrandDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketBrandDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MarketBrandDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    importMarketBrands(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration/import-brands";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processImportMarketBrands(_response);
        }, (_response) => {
            if (_response.status)
                return this.processImportMarketBrands(_response);
            throw _response;
        });
    }

    protected processImportMarketBrands(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    importProducts(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/configuration/import-products";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processImportProducts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processImportProducts(_response);
            throw _response;
        });
    }

    protected processImportProducts(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getProducts(): ng.IPromise<ProductDictionaryDTO[]> {
        let url_ = this.baseUrl + "/api/configuration/product";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetProducts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetProducts(_response);
            throw _response;
        });
    }

    protected processGetProducts(response: any): ng.IPromise<ProductDictionaryDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductDictionaryDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductDictionaryDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateExFactory(body: CalculateExFactoryRequestDTO | undefined): ng.IPromise<SkuExFactoryDTO[]> {
        let url_ = this.baseUrl + "/api/ex-factory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCalculateExFactory(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCalculateExFactory(_response);
            throw _response;
        });
    }

    protected processCalculateExFactory(response: any): ng.IPromise<SkuExFactoryDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SkuExFactoryDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SkuExFactoryDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportTable(body: TableExportDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/export/table";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportTable(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportTable(_response);
            throw _response;
        });
    }

    protected processExportTable(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getForecastById(id: number): ng.IPromise<ForecastDTO> {
        let url_ = this.baseUrl + "/api/forecast/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetForecastById(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetForecastById(_response);
            throw _response;
        });
    }

    protected processGetForecastById(response: any): ng.IPromise<ForecastDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateForecast(id: number, body: ForecastData | undefined): ng.IPromise<ForecastMetadataDTO> {
        let url_ = this.baseUrl + "/api/forecast/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateForecast(_response);
            throw _response;
        });
    }

    protected processUpdateForecast(response: any): ng.IPromise<ForecastMetadataDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastMetadataDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastMetadataDTO>(null as any);
    }

    /**
     * @return Success
     */
    deleteForecast(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDeleteForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDeleteForecast(_response);
            throw _response;
        });
    }

    protected processDeleteForecast(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCorrection(id: number): ng.IPromise<ForecastData> {
        let url_ = this.baseUrl + "/api/forecast/{id}/correction-after-defence";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCorrection(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCorrection(_response);
            throw _response;
        });
    }

    protected processGetCorrection(response: any): ng.IPromise<ForecastData> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastData;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastData>(null as any);
    }

    /**
     * @return Success
     */
    createForecast(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/forecast";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateForecast(_response);
            throw _response;
        });
    }

    protected processCreateForecast(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param name (optional) 
     * @param budgetYear (optional) 
     * @param showMy (optional) 
     * @return Success
     */
    simpleForecastSearch(name: string | undefined, budgetYear: number | undefined, showMy: boolean | undefined): ng.IPromise<ForecastSimpleSearchDTO[]> {
        let url_ = this.baseUrl + "/api/forecast?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (budgetYear === null)
            throw new Error("The parameter 'budgetYear' cannot be null.");
        else if (budgetYear !== undefined)
            url_ += "BudgetYear=" + encodeURIComponent("" + budgetYear) + "&";
        if (showMy === null)
            throw new Error("The parameter 'showMy' cannot be null.");
        else if (showMy !== undefined)
            url_ += "ShowMy=" + encodeURIComponent("" + showMy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSimpleForecastSearch(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSimpleForecastSearch(_response);
            throw _response;
        });
    }

    protected processSimpleForecastSearch(response: any): ng.IPromise<ForecastSimpleSearchDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastSimpleSearchDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastSimpleSearchDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateForecastName(id: number, body: UpdateForecastNameDTO | undefined): ng.IPromise<ForecastMetadataDTO> {
        let url_ = this.baseUrl + "/api/forecast/{id}/name";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateForecastName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateForecastName(_response);
            throw _response;
        });
    }

    protected processUpdateForecastName(response: any): ng.IPromise<ForecastMetadataDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastMetadataDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastMetadataDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initializeForecast(id: number, body: InitializeForecastCommand | undefined): ng.IPromise<ForecastMetadataDTO> {
        let url_ = this.baseUrl + "/api/forecast/initialize/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processInitializeForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processInitializeForecast(_response);
            throw _response;
        });
    }

    protected processInitializeForecast(response: any): ng.IPromise<ForecastMetadataDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastMetadataDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastMetadataDTO>(null as any);
    }

    /**
     * @param name (optional) 
     * @return Success
     */
    isForecastNameUnique(forecastId: number, name: string | undefined): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/forecast/{forecastId}/name/unique?";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsForecastNameUnique(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsForecastNameUnique(_response);
            throw _response;
        });
    }

    protected processIsForecastNameUnique(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveForecastAsNew(forecastId: number, body: UpdateForecastNameDTO | undefined): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/forecast/{forecastId}/saveAsNew";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSaveForecastAsNew(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSaveForecastAsNew(_response);
            throw _response;
        });
    }

    protected processSaveForecastAsNew(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    getForecastRisks(): ng.IPromise<RiskDTO[]> {
        let url_ = this.baseUrl + "/api/forecast/risk";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetForecastRisks(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetForecastRisks(_response);
            throw _response;
        });
    }

    protected processGetForecastRisks(response: any): ng.IPromise<RiskDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RiskDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<RiskDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getForecastProductCodes(body: ForecastProductCodesQuery | undefined): ng.IPromise<ForecastProductCodesDTO[]> {
        let url_ = this.baseUrl + "/api/forecast/changeProductCodesDashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetForecastProductCodes(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetForecastProductCodes(_response);
            throw _response;
        });
    }

    protected processGetForecastProductCodes(response: any): ng.IPromise<ForecastProductCodesDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastProductCodesDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastProductCodesDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    parseChangeOracleIndexFile(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/changeProductCodes/parse";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processParseChangeOracleIndexFile(_response);
        }, (_response) => {
            if (_response.status)
                return this.processParseChangeOracleIndexFile(_response);
            throw _response;
        });
    }

    protected processParseChangeOracleIndexFile(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeOracleIndex(body: ChangeOracleIndexCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/changeProductCodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processChangeOracleIndex(_response);
        }, (_response) => {
            if (_response.status)
                return this.processChangeOracleIndex(_response);
            throw _response;
        });
    }

    protected processChangeOracleIndex(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getChangeOracleIndexTemplate(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/changeProductCodes";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetChangeOracleIndexTemplate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetChangeOracleIndexTemplate(_response);
            throw _response;
        });
    }

    protected processGetChangeOracleIndexTemplate(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAssumptions(body: AssumptionsExportDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/assumptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processExportAssumptions(_response);
        }, (_response) => {
            if (_response.status)
                return this.processExportAssumptions(_response);
            throw _response;
        });
    }

    protected processExportAssumptions(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @return Success
     */
    getForecastProductCode(searchString: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/forecast/product-code?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetForecastProductCode(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetForecastProductCode(_response);
            throw _response;
        });
    }

    protected processGetForecastProductCode(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getForecastMarketDump(forecastId: number): ng.IPromise<ForecastMarketDumpDTO> {
        let url_ = this.baseUrl + "/api/forecast/{forecastId}/market-dump";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetForecastMarketDump(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetForecastMarketDump(_response);
            throw _response;
        });
    }

    protected processGetForecastMarketDump(response: any): ng.IPromise<ForecastMarketDumpDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastMarketDumpDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastMarketDumpDTO>(null as any);
    }

    /**
     * @return Success
     */
    getForecastMarketDumpSkus(forecastId: number): ng.IPromise<ImsProductDTO[]> {
        let url_ = this.baseUrl + "/api/forecast/{forecastId}/market-dump/skus";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetForecastMarketDumpSkus(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetForecastMarketDumpSkus(_response);
            throw _response;
        });
    }

    protected processGetForecastMarketDumpSkus(response: any): ng.IPromise<ImsProductDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsProductDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsProductDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getBrandsByMarket(marketId: number): ng.IPromise<BrandInMarketDTO[]> {
        let url_ = this.baseUrl + "/api/forecast/parameters/brands/{marketId}";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined.");
        url_ = url_.replace("{marketId}", encodeURIComponent("" + marketId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBrandsByMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBrandsByMarket(_response);
            throw _response;
        });
    }

    protected processGetBrandsByMarket(response: any): ng.IPromise<BrandInMarketDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrandInMarketDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrandInMarketDTO[]>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortField (optional) 
     * @param sortType (optional) 
     * @param name (optional) 
     * @param marketName (optional) 
     * @param productManager (optional) 
     * @param modificationTime (optional) 
     * @param productCode (optional) 
     * @param budgetYear (optional) 
     * @param marketCountry (optional) 
     * @return Success
     */
    getDraftForecasts(page: number | undefined, pageSize: number | undefined, sortField: string | undefined, sortType: string | undefined, name: string | undefined, marketName: string | undefined, productManager: string | undefined, modificationTime: string | undefined, productCode: string | undefined, budgetYear: number | undefined, marketCountry: string | undefined): ng.IPromise<ForecastGridDTOPageableListResult> {
        let url_ = this.baseUrl + "/api/forecast/process/draft?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (marketName === null)
            throw new Error("The parameter 'marketName' cannot be null.");
        else if (marketName !== undefined)
            url_ += "MarketName=" + encodeURIComponent("" + marketName) + "&";
        if (productManager === null)
            throw new Error("The parameter 'productManager' cannot be null.");
        else if (productManager !== undefined)
            url_ += "ProductManager=" + encodeURIComponent("" + productManager) + "&";
        if (modificationTime === null)
            throw new Error("The parameter 'modificationTime' cannot be null.");
        else if (modificationTime !== undefined)
            url_ += "ModificationTime=" + encodeURIComponent("" + modificationTime) + "&";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (budgetYear === null)
            throw new Error("The parameter 'budgetYear' cannot be null.");
        else if (budgetYear !== undefined)
            url_ += "BudgetYear=" + encodeURIComponent("" + budgetYear) + "&";
        if (marketCountry === null)
            throw new Error("The parameter 'marketCountry' cannot be null.");
        else if (marketCountry !== undefined)
            url_ += "MarketCountry=" + encodeURIComponent("" + marketCountry) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetDraftForecasts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetDraftForecasts(_response);
            throw _response;
        });
    }

    protected processGetDraftForecasts(response: any): ng.IPromise<ForecastGridDTOPageableListResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastGridDTOPageableListResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastGridDTOPageableListResult>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortField (optional) 
     * @param sortType (optional) 
     * @param name (optional) 
     * @param marketName (optional) 
     * @param productManager (optional) 
     * @param modificationTime (optional) 
     * @param productCode (optional) 
     * @param budgetYear (optional) 
     * @param marketCountry (optional) 
     * @param status (optional) 
     * @param marketType (optional) 
     * @param assignedPerson (optional) 
     * @param creationTime (optional) 
     * @param budgetVersionUId (optional) 
     * @return Success
     */
    getCreatedForecasts(page: number | undefined, pageSize: number | undefined, sortField: string | undefined, sortType: string | undefined, name: string | undefined, marketName: string | undefined, productManager: string | undefined, modificationTime: string | undefined, productCode: string | undefined, budgetYear: number | undefined, marketCountry: string | undefined, status: ForecastStatus[] | undefined, marketType: string[] | undefined, assignedPerson: string | undefined, creationTime: string | undefined, budgetVersionUId: string | undefined): ng.IPromise<CreatedForecastGridDTOPageableListResult> {
        let url_ = this.baseUrl + "/api/forecast/process/created?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (marketName === null)
            throw new Error("The parameter 'marketName' cannot be null.");
        else if (marketName !== undefined)
            url_ += "MarketName=" + encodeURIComponent("" + marketName) + "&";
        if (productManager === null)
            throw new Error("The parameter 'productManager' cannot be null.");
        else if (productManager !== undefined)
            url_ += "ProductManager=" + encodeURIComponent("" + productManager) + "&";
        if (modificationTime === null)
            throw new Error("The parameter 'modificationTime' cannot be null.");
        else if (modificationTime !== undefined)
            url_ += "ModificationTime=" + encodeURIComponent("" + modificationTime) + "&";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (budgetYear === null)
            throw new Error("The parameter 'budgetYear' cannot be null.");
        else if (budgetYear !== undefined)
            url_ += "BudgetYear=" + encodeURIComponent("" + budgetYear) + "&";
        if (marketCountry === null)
            throw new Error("The parameter 'marketCountry' cannot be null.");
        else if (marketCountry !== undefined)
            url_ += "MarketCountry=" + encodeURIComponent("" + marketCountry) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (marketType === null)
            throw new Error("The parameter 'marketType' cannot be null.");
        else if (marketType !== undefined)
            marketType && marketType.forEach(item => { url_ += "MarketType=" + encodeURIComponent("" + item) + "&"; });
        if (assignedPerson === null)
            throw new Error("The parameter 'assignedPerson' cannot be null.");
        else if (assignedPerson !== undefined)
            url_ += "AssignedPerson=" + encodeURIComponent("" + assignedPerson) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent("" + creationTime) + "&";
        if (budgetVersionUId === null)
            throw new Error("The parameter 'budgetVersionUId' cannot be null.");
        else if (budgetVersionUId !== undefined)
            url_ += "BudgetVersionUId=" + encodeURIComponent("" + budgetVersionUId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetCreatedForecasts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetCreatedForecasts(_response);
            throw _response;
        });
    }

    protected processGetCreatedForecasts(response: any): ng.IPromise<CreatedForecastGridDTOPageableListResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedForecastGridDTOPageableListResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<CreatedForecastGridDTOPageableListResult>(null as any);
    }

    /**
     * @return Success
     */
    getForecastHistory(forecastId: number): ng.IPromise<ForecastHistoryDTO[]> {
        let url_ = this.baseUrl + "/api/forecast/process/{forecastId}/history";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetForecastHistory(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetForecastHistory(_response);
            throw _response;
        });
    }

    protected processGetForecastHistory(response: any): ng.IPromise<ForecastHistoryDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForecastHistoryDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ForecastHistoryDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendForecastToApproval(forecastId: number, body: SendToApprovalCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/process/{forecastId}/send-to-approval";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendForecastToApproval(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendForecastToApproval(_response);
            throw _response;
        });
    }

    protected processSendForecastToApproval(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    approveForecast(forecastId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/process/{forecastId}/approve";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processApproveForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processApproveForecast(_response);
            throw _response;
        });
    }

    protected processApproveForecast(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendForecastToCorrection(forecastId: number, body: CommentWrapper | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/process/{forecastId}/send-to-correction";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSendForecastToCorrection(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSendForecastToCorrection(_response);
            throw _response;
        });
    }

    protected processSendForecastToCorrection(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    correctionAfterDefence(forecastId: number, body: CorrectForecastAfterDefenceCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/process/{forecastId}/correction-after-defence";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCorrectionAfterDefence(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCorrectionAfterDefence(_response);
            throw _response;
        });
    }

    protected processCorrectionAfterDefence(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    delistForecast(forecastId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/process/{forecastId}/delist";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processDelistForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processDelistForecast(_response);
            throw _response;
        });
    }

    protected processDelistForecast(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    enlistForecast(forecastId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/process/{forecastId}/enlist";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processEnlistForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processEnlistForecast(_response);
            throw _response;
        });
    }

    protected processEnlistForecast(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    removeCorrectionAfterDefence(forecastId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/process/{forecastId}/remove-correction-after-defence";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemoveCorrectionAfterDefence(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemoveCorrectionAfterDefence(_response);
            throw _response;
        });
    }

    protected processRemoveCorrectionAfterDefence(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeProductManager(body: ChangeForecastProductManagerCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/forecast/process/product-manager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processChangeProductManager(_response);
        }, (_response) => {
            if (_response.status)
                return this.processChangeProductManager(_response);
            throw _response;
        });
    }

    protected processChangeProductManager(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param startMonth (optional) 
     * @param endMonth (optional) 
     * @param oracleIndex (optional) 
     * @param dbConnection (optional) 
     * @return Success
     */
    getRollingForecastInitialData(startMonth: Date | undefined, endMonth: Date | undefined, oracleIndex: string | undefined, dbConnection: DbConnection | undefined): ng.IPromise<BrandInitializationDataResult> {
        let url_ = this.baseUrl + "/api/ims/rollingForecast?";
        if (startMonth === null)
            throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined)
            url_ += "StartMonth=" + encodeURIComponent(startMonth ? "" + startMonth.toISOString() : "") + "&";
        if (endMonth === null)
            throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined)
            url_ += "EndMonth=" + encodeURIComponent(endMonth ? "" + endMonth.toISOString() : "") + "&";
        if (oracleIndex === null)
            throw new Error("The parameter 'oracleIndex' cannot be null.");
        else if (oracleIndex !== undefined)
            url_ += "OracleIndex=" + encodeURIComponent("" + oracleIndex) + "&";
        if (dbConnection === null)
            throw new Error("The parameter 'dbConnection' cannot be null.");
        else if (dbConnection !== undefined)
            url_ += "DbConnection=" + encodeURIComponent("" + dbConnection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetRollingForecastInitialData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetRollingForecastInitialData(_response);
            throw _response;
        });
    }

    protected processGetRollingForecastInitialData(response: any): ng.IPromise<BrandInitializationDataResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrandInitializationDataResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrandInitializationDataResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getLastHistoricalDataDate(body: LastHistoricalDataDateQuery | undefined): ng.IPromise<LastHistoricalDataDateDTO[]> {
        let url_ = this.baseUrl + "/api/ims/lastHistoricalDataDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetLastHistoricalDataDate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetLastHistoricalDataDate(_response);
            throw _response;
        });
    }

    protected processGetLastHistoricalDataDate(response: any): ng.IPromise<LastHistoricalDataDateDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LastHistoricalDataDateDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<LastHistoricalDataDateDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPharmacyMarketShare(body: PharmInTotalIMSShareQuery | undefined): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/ims/pharmacy-market/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPharmacyMarketShare(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPharmacyMarketShare(_response);
            throw _response;
        });
    }

    protected processGetPharmacyMarketShare(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param forecastId (optional) 
     * @return Success
     */
    getImsData(forecastId: number | undefined): ng.IPromise<ImsLatestImportDateDTO> {
        let url_ = this.baseUrl + "/api/ims/latestData?";
        if (forecastId === null)
            throw new Error("The parameter 'forecastId' cannot be null.");
        else if (forecastId !== undefined)
            url_ += "forecastId=" + encodeURIComponent("" + forecastId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetImsData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetImsData(_response);
            throw _response;
        });
    }

    protected processGetImsData(response: any): ng.IPromise<ImsLatestImportDateDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsLatestImportDateDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsLatestImportDateDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMarketValue(body: MarketValueQuery | undefined): ng.IPromise<DataResultDTO> {
        let url_ = this.baseUrl + "/api/ims/market/filter/value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMarketValue(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMarketValue(_response);
            throw _response;
        });
    }

    protected processGetMarketValue(response: any): ng.IPromise<DataResultDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataResultDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DataResultDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getImsMarketSkusValue(body: MarketSkusValueQuery | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/ims/market/value/skus/report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetImsMarketSkusValue(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetImsMarketSkusValue(_response);
            throw _response;
        });
    }

    protected processGetImsMarketSkusValue(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getIMSBrands(body: BrandQuery | undefined): ng.IPromise<BrandDTOPageableListResult> {
        let url_ = this.baseUrl + "/api/ims/brand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetIMSBrands(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetIMSBrands(_response);
            throw _response;
        });
    }

    protected processGetIMSBrands(response: any): ng.IPromise<BrandDTOPageableListResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrandDTOPageableListResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrandDTOPageableListResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBrandsByFilter(body: BrandByFilterQuery | undefined): ng.IPromise<ImsProductDTO[]> {
        let url_ = this.baseUrl + "/api/ims/market/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBrandsByFilter(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBrandsByFilter(_response);
            throw _response;
        });
    }

    protected processGetBrandsByFilter(response: any): ng.IPromise<ImsProductDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsProductDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsProductDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getPharmacyMarkets(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims/pharmacy-market";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPharmacyMarkets(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPharmacyMarkets(_response);
            throw _response;
        });
    }

    protected processGetPharmacyMarkets(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @return Success
     */
    getMolecues(searchString: string | undefined): ng.IPromise<MoleculeDTO[]> {
        let url_ = this.baseUrl + "/api/ims/molecule?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMolecues(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMolecues(_response);
            throw _response;
        });
    }

    protected processGetMolecues(response: any): ng.IPromise<MoleculeDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MoleculeDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MoleculeDTO[]>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @return Success
     */
    getAtc3(searchString: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims/atc3?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAtc3(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAtc3(_response);
            throw _response;
        });
    }

    protected processGetAtc3(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @param atc3 (optional) 
     * @return Success
     */
    getAtc4(searchString: string | undefined, atc3: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims/atc4?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (atc3 === null)
            throw new Error("The parameter 'atc3' cannot be null.");
        else if (atc3 !== undefined)
            url_ += "Atc3=" + encodeURIComponent("" + atc3) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAtc4(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAtc4(_response);
            throw _response;
        });
    }

    protected processGetAtc4(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getPrescriptionMarket(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims/perscirption-market";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPrescriptionMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPrescriptionMarket(_response);
            throw _response;
        });
    }

    protected processGetPrescriptionMarket(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getMoleculeType(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims/molecule-type";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMoleculeType(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMoleculeType(_response);
            throw _response;
        });
    }

    protected processGetMoleculeType(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param searchString (optional) 
     * @param molecules (optional) 
     * @return Success
     */
    getNfc3(searchString: string | undefined, molecules: string[] | undefined): ng.IPromise<Nfc3DTO[]> {
        let url_ = this.baseUrl + "/api/ims/nfc3?";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (molecules === null)
            throw new Error("The parameter 'molecules' cannot be null.");
        else if (molecules !== undefined)
            molecules && molecules.forEach(item => { url_ += "Molecules=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetNfc3(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetNfc3(_response);
            throw _response;
        });
    }

    protected processGetNfc3(response: any): ng.IPromise<Nfc3DTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Nfc3DTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Nfc3DTO[]>(null as any);
    }

    /**
     * @param query (optional) 
     * @return Success
     */
    getNewProductList(query: ImsNewProductsQuery | undefined): ng.IPromise<BrandInMarketDTO[]> {
        let url_ = this.baseUrl + "/api/ims/new-products?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetNewProductList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetNewProductList(_response);
            throw _response;
        });
    }

    protected processGetNewProductList(response: any): ng.IPromise<BrandInMarketDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrandInMarketDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrandInMarketDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    computeMachineLearning(body: MachineLearningDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/ml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processComputeMachineLearning(_response);
        }, (_response) => {
            if (_response.status)
                return this.processComputeMachineLearning(_response);
            throw _response;
        });
    }

    protected processComputeMachineLearning(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyMachineLearning(body: ModelIdentifier | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/ml/notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processNotifyMachineLearning(_response);
        }, (_response) => {
            if (_response.status)
                return this.processNotifyMachineLearning(_response);
            throw _response;
        });
    }

    protected processNotifyMachineLearning(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getMlModelForForecast(forecastId: number): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ml/forecast/{forecastId}";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMlModelForForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMlModelForForecast(_response);
            throw _response;
        });
    }

    protected processGetMlModelForForecast(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    calculateModel(forecastUId: string): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/ml/calculate/{forecastUId}";
        if (forecastUId === undefined || forecastUId === null)
            throw new Error("The parameter 'forecastUId' must be defined.");
        url_ = url_.replace("{forecastUId}", encodeURIComponent("" + forecastUId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCalculateModel(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCalculateModel(_response);
            throw _response;
        });
    }

    protected processCalculateModel(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    isMLEnabled(method: ForecastMethod): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/ml/is-enabled/{method}";
        if (method === undefined || method === null)
            throw new Error("The parameter 'method' must be defined.");
        url_ = url_.replace("{method}", encodeURIComponent("" + method));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsMLEnabled(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsMLEnabled(_response);
            throw _response;
        });
    }

    protected processIsMLEnabled(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param isActive (optional) 
     * @return Success
     */
    getMarketDefinitions(isActive: boolean | undefined): ng.IPromise<MarketDefinitionDTO[]> {
        let url_ = this.baseUrl + "/api/market-definition?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMarketDefinitions(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMarketDefinitions(_response);
            throw _response;
        });
    }

    protected processGetMarketDefinitions(response: any): ng.IPromise<MarketDefinitionDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketDefinitionDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MarketDefinitionDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMarketDefinition(body: MarketDefinitionDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateMarketDefinition(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateMarketDefinition(_response);
            throw _response;
        });
    }

    protected processCreateMarketDefinition(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMarketDefinition(body: MarketDefinitionDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market-definition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateMarketDefinition(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateMarketDefinition(_response);
            throw _response;
        });
    }

    protected processUpdateMarketDefinition(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param name (optional) 
     * @return Success
     */
    isMarketDefinitionUniqueName(id: number | undefined, name: string | undefined): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/market-definition/unique?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsMarketDefinitionUniqueName(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsMarketDefinitionUniqueName(_response);
            throw _response;
        });
    }

    protected processIsMarketDefinitionUniqueName(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    toggleMarketDefinitionIsActive(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market-definition/{id}/toggle-activity";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processToggleMarketDefinitionIsActive(_response);
        }, (_response) => {
            if (_response.status)
                return this.processToggleMarketDefinitionIsActive(_response);
            throw _response;
        });
    }

    protected processToggleMarketDefinitionIsActive(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param oracleIndex (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getToplingRollingForecast(oracleIndex: string | undefined, startDate: Date | undefined, endDate: Date | undefined): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/ml/topline/rolling-forecast?";
        if (oracleIndex === null)
            throw new Error("The parameter 'oracleIndex' cannot be null.");
        else if (oracleIndex !== undefined)
            url_ += "OracleIndex=" + encodeURIComponent("" + oracleIndex) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetToplingRollingForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetToplingRollingForecast(_response);
            throw _response;
        });
    }

    protected processGetToplingRollingForecast(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getToplineRollingFroecasts(body: TLRollingForecastManySkusQuery | undefined): ng.IPromise<RollingForecastVolumeDTO[]> {
        let url_ = this.baseUrl + "/api/ml/topline/rolling-forecast";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetToplineRollingFroecasts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetToplineRollingFroecasts(_response);
            throw _response;
        });
    }

    protected processGetToplineRollingFroecasts(response: any): ng.IPromise<RollingForecastVolumeDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RollingForecastVolumeDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<RollingForecastVolumeDTO[]>(null as any);
    }

    /**
     * @param productCodes (optional) 
     * @return Success
     */
    getProductsPrices(productCodes: string[] | undefined): ng.IPromise<ProductPriceDTO[]> {
        let url_ = this.baseUrl + "/api/ml/price?";
        if (productCodes === null)
            throw new Error("The parameter 'productCodes' cannot be null.");
        else if (productCodes !== undefined)
            productCodes && productCodes.forEach(item => { url_ += "productCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetProductsPrices(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetProductsPrices(_response);
            throw _response;
        });
    }

    protected processGetProductsPrices(response: any): ng.IPromise<ProductPriceDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductPriceDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductPriceDTO[]>(null as any);
    }

    /**
     * @param productCodes (optional) 
     * @return Success
     */
    getMlIndexData(productCodes: string[] | undefined): ng.IPromise<MLOracleIndexDataDTO[]> {
        let url_ = this.baseUrl + "/api/ml/product-data?";
        if (productCodes === null)
            throw new Error("The parameter 'productCodes' cannot be null.");
        else if (productCodes !== undefined)
            productCodes && productCodes.forEach(item => { url_ += "productCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMlIndexData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMlIndexData(_response);
            throw _response;
        });
    }

    protected processGetMlIndexData(response: any): ng.IPromise<MLOracleIndexDataDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MLOracleIndexDataDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MLOracleIndexDataDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getValuesForCollection(body: SubstitutionValuesRequest | undefined): ng.IPromise<{ [key: string]: string; }[]> {
        let url_ = this.baseUrl + "/api/notification/GetValuesForCollection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetValuesForCollection(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetValuesForCollection(_response);
            throw _response;
        });
    }

    protected processGetValuesForCollection(response: any): ng.IPromise<{ [key: string]: string; }[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; }[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<{ [key: string]: string; }[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getValuesForEntity(body: SubstitutionValuesRequest | undefined): ng.IPromise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/notification/GetValuesForEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetValuesForEntity(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetValuesForEntity(_response);
            throw _response;
        });
    }

    protected processGetValuesForEntity(response: any): ng.IPromise<{ [key: string]: string; }> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getNotificationRecipients(body: NotificationRecipientsRequest | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/notification/GetNotificationRecipients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetNotificationRecipients(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetNotificationRecipients(_response);
            throw _response;
        });
    }

    protected processGetNotificationRecipients(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchProductWithOwners(body: PlannerProductSearchOptions | undefined): ng.IPromise<ProductWithAssignmentsDTOPageableListResult> {
        let url_ = this.baseUrl + "/api/oracle-products/search/toplineProductOwners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSearchProductWithOwners(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSearchProductWithOwners(_response);
            throw _response;
        });
    }

    protected processSearchProductWithOwners(response: any): ng.IPromise<ProductWithAssignmentsDTOPageableListResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductWithAssignmentsDTOPageableListResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductWithAssignmentsDTOPageableListResult>(null as any);
    }

    /**
     * @return Success
     */
    getOracleBrands(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/oracle-products/brand";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOracleBrands(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOracleBrands(_response);
            throw _response;
        });
    }

    protected processGetOracleBrands(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    getOracleMarkets(): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/oracle-products/market";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOracleMarkets(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOracleMarkets(_response);
            throw _response;
        });
    }

    protected processGetOracleMarkets(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param market (optional) 
     * @return Success
     */
    getOracleRegions(market: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/oracle-products/region?";
        if (market === null)
            throw new Error("The parameter 'market' cannot be null.");
        else if (market !== undefined)
            url_ += "Market=" + encodeURIComponent("" + market) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOracleRegions(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOracleRegions(_response);
            throw _response;
        });
    }

    protected processGetOracleRegions(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param region (optional) 
     * @return Success
     */
    getOracleBusinessUnits(region: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/oracle-products/businessUnit?";
        if (region === null)
            throw new Error("The parameter 'region' cannot be null.");
        else if (region !== undefined)
            url_ += "Region=" + encodeURIComponent("" + region) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOracleBusinessUnits(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOracleBusinessUnits(_response);
            throw _response;
        });
    }

    protected processGetOracleBusinessUnits(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param businessUnit (optional) 
     * @return Success
     */
    getOracleLines(businessUnit: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/oracle-products/line?";
        if (businessUnit === null)
            throw new Error("The parameter 'businessUnit' cannot be null.");
        else if (businessUnit !== undefined)
            url_ += "BusinessUnit=" + encodeURIComponent("" + businessUnit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOracleLines(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOracleLines(_response);
            throw _response;
        });
    }

    protected processGetOracleLines(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    fillPnlIndexDictionary(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/product-owners/fill-pnl-index-dictionary";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processFillPnlIndexDictionary(_response);
        }, (_response) => {
            if (_response.status)
                return this.processFillPnlIndexDictionary(_response);
            throw _response;
        });
    }

    protected processFillPnlIndexDictionary(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getProductOwnerList(): ng.IPromise<UserDTO[]> {
        let url_ = this.baseUrl + "/api/product-owners/list";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetProductOwnerList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetProductOwnerList(_response);
            throw _response;
        });
    }

    protected processGetProductOwnerList(response: any): ng.IPromise<UserDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<UserDTO[]>(null as any);
    }

    /**
     * @param budgetVersionUId (optional) 
     * @return Success
     */
    getOwnerWithProduct(budgetVersionUId: string | undefined): ng.IPromise<ProductWithOwnerAndApproverDTO[]> {
        let url_ = this.baseUrl + "/api/product-owners/owner-with-product?";
        if (budgetVersionUId === null)
            throw new Error("The parameter 'budgetVersionUId' cannot be null.");
        else if (budgetVersionUId !== undefined)
            url_ += "BudgetVersionUId=" + encodeURIComponent("" + budgetVersionUId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetOwnerWithProduct(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetOwnerWithProduct(_response);
            throw _response;
        });
    }

    protected processGetOwnerWithProduct(response: any): ng.IPromise<ProductWithOwnerAndApproverDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductWithOwnerAndApproverDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProductWithOwnerAndApproverDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    computeRegression(body: RegressionDTO | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/regression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processComputeRegression(_response);
        }, (_response) => {
            if (_response.status)
                return this.processComputeRegression(_response);
            throw _response;
        });
    }

    protected processComputeRegression(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getPLReportForForecast(forecastId: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/report/masterPL/forecast/{forecastId}";
        if (forecastId === undefined || forecastId === null)
            throw new Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPLReportForForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPLReportForForecast(_response);
            throw _response;
        });
    }

    protected processGetPLReportForForecast(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @param sortField (optional) 
     * @param sortType (optional) 
     * @param name (optional) 
     * @param marketName (optional) 
     * @param productManager (optional) 
     * @param modificationTime (optional) 
     * @param productCode (optional) 
     * @param budgetYear (optional) 
     * @param marketCountry (optional) 
     * @param status (optional) 
     * @param marketType (optional) 
     * @param assignedPerson (optional) 
     * @param creationTime (optional) 
     * @param budgetVersionUId (optional) 
     * @return Success
     */
    getMarketPLReportForForecast(page: number | undefined, pageSize: number | undefined, sortField: string | undefined, sortType: string | undefined, name: string | undefined, marketName: string | undefined, productManager: string | undefined, modificationTime: string | undefined, productCode: string | undefined, budgetYear: number | undefined, marketCountry: string | undefined, status: ForecastStatus[] | undefined, marketType: string[] | undefined, assignedPerson: string | undefined, creationTime: string | undefined, budgetVersionUId: string | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/report/masterPL/markets?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortField === null)
            throw new Error("The parameter 'sortField' cannot be null.");
        else if (sortField !== undefined)
            url_ += "SortField=" + encodeURIComponent("" + sortField) + "&";
        if (sortType === null)
            throw new Error("The parameter 'sortType' cannot be null.");
        else if (sortType !== undefined)
            url_ += "SortType=" + encodeURIComponent("" + sortType) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (marketName === null)
            throw new Error("The parameter 'marketName' cannot be null.");
        else if (marketName !== undefined)
            url_ += "MarketName=" + encodeURIComponent("" + marketName) + "&";
        if (productManager === null)
            throw new Error("The parameter 'productManager' cannot be null.");
        else if (productManager !== undefined)
            url_ += "ProductManager=" + encodeURIComponent("" + productManager) + "&";
        if (modificationTime === null)
            throw new Error("The parameter 'modificationTime' cannot be null.");
        else if (modificationTime !== undefined)
            url_ += "ModificationTime=" + encodeURIComponent("" + modificationTime) + "&";
        if (productCode === null)
            throw new Error("The parameter 'productCode' cannot be null.");
        else if (productCode !== undefined)
            url_ += "ProductCode=" + encodeURIComponent("" + productCode) + "&";
        if (budgetYear === null)
            throw new Error("The parameter 'budgetYear' cannot be null.");
        else if (budgetYear !== undefined)
            url_ += "BudgetYear=" + encodeURIComponent("" + budgetYear) + "&";
        if (marketCountry === null)
            throw new Error("The parameter 'marketCountry' cannot be null.");
        else if (marketCountry !== undefined)
            url_ += "MarketCountry=" + encodeURIComponent("" + marketCountry) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (marketType === null)
            throw new Error("The parameter 'marketType' cannot be null.");
        else if (marketType !== undefined)
            marketType && marketType.forEach(item => { url_ += "MarketType=" + encodeURIComponent("" + item) + "&"; });
        if (assignedPerson === null)
            throw new Error("The parameter 'assignedPerson' cannot be null.");
        else if (assignedPerson !== undefined)
            url_ += "AssignedPerson=" + encodeURIComponent("" + assignedPerson) + "&";
        if (creationTime === null)
            throw new Error("The parameter 'creationTime' cannot be null.");
        else if (creationTime !== undefined)
            url_ += "CreationTime=" + encodeURIComponent("" + creationTime) + "&";
        if (budgetVersionUId === null)
            throw new Error("The parameter 'budgetVersionUId' cannot be null.");
        else if (budgetVersionUId !== undefined)
            url_ += "BudgetVersionUId=" + encodeURIComponent("" + budgetVersionUId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMarketPLReportForForecast(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMarketPLReportForForecast(_response);
            throw _response;
        });
    }

    protected processGetMarketPLReportForForecast(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    prepareMarketContentReport(body: MarketContentQuery | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/report/market/content-prepare";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPrepareMarketContentReport(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPrepareMarketContentReport(_response);
            throw _response;
        });
    }

    protected processPrepareMarketContentReport(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyMarketContent(body: FileIdentifier | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/report/market/content-notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processNotifyMarketContent(_response);
        }, (_response) => {
            if (_response.status)
                return this.processNotifyMarketContent(_response);
            throw _response;
        });
    }

    protected processNotifyMarketContent(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param userName (optional) 
     * @param fileUri (optional) 
     * @return Success
     */
    getMakretContentReport(userName: string | undefined, fileUri: string | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/report/market/content?";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (fileUri === null)
            throw new Error("The parameter 'fileUri' cannot be null.");
        else if (fileUri !== undefined)
            url_ += "FileUri=" + encodeURIComponent("" + fileUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMakretContentReport(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMakretContentReport(_response);
            throw _response;
        });
    }

    protected processGetMakretContentReport(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param forecastStartDate (optional) 
     * @param oracleIndexes (optional) 
     * @return Success
     */
    getVmiData(forecastStartDate: Date | undefined, oracleIndexes: string[] | undefined): ng.IPromise<VMIOracleIndexDataDTO[]> {
        let url_ = this.baseUrl + "/api/vmi/rotationInfo?";
        if (forecastStartDate === null)
            throw new Error("The parameter 'forecastStartDate' cannot be null.");
        else if (forecastStartDate !== undefined)
            url_ += "forecastStartDate=" + encodeURIComponent(forecastStartDate ? "" + forecastStartDate.toISOString() : "") + "&";
        if (oracleIndexes === null)
            throw new Error("The parameter 'oracleIndexes' cannot be null.");
        else if (oracleIndexes !== undefined)
            oracleIndexes && oracleIndexes.forEach(item => { url_ += "oracleIndexes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetVmiData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetVmiData(_response);
            throw _response;
        });
    }

    protected processGetVmiData(response: any): ng.IPromise<VMIOracleIndexDataDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VMIOracleIndexDataDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<VMIOracleIndexDataDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateVmiProducts(body: FileMarketDTO | undefined): ng.IPromise<MarketFileValidationResult> {
        let url_ = this.baseUrl + "/api/vmi/validate-products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processValidateVmiProducts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processValidateVmiProducts(_response);
            throw _response;
        });
    }

    protected processValidateVmiProducts(response: any): ng.IPromise<MarketFileValidationResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketFileValidationResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MarketFileValidationResult>(null as any);
    }
}

export class IMSIOClient {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param forecastId (optional) 
     * @return Success
     */
    getImsData(forecastId: number | undefined): ng.IPromise<ImsLatestImportDateDTO> {
        let url_ = this.baseUrl + "/api/ims-io/latestData?";
        if (forecastId === null)
            throw new Error("The parameter 'forecastId' cannot be null.");
        else if (forecastId !== undefined)
            url_ += "forecastId=" + encodeURIComponent("" + forecastId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetImsData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetImsData(_response);
            throw _response;
        });
    }

    protected processGetImsData(response: any): ng.IPromise<ImsLatestImportDateDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsLatestImportDateDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsLatestImportDateDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMarketValue(body: MarketIOValueQuery | undefined): ng.IPromise<DataResultDTO> {
        let url_ = this.baseUrl + "/api/ims-io/market/filter/value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMarketValue(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMarketValue(_response);
            throw _response;
        });
    }

    protected processGetMarketValue(response: any): ng.IPromise<DataResultDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataResultDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DataResultDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getImsMarketSkusValue(body: MarketIOSkusValueQuery | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/ims-io/market/value/skus/report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetImsMarketSkusValue(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetImsMarketSkusValue(_response);
            throw _response;
        });
    }

    protected processGetImsMarketSkusValue(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getIMSBrands(body: IMSIOBrandQuery | undefined): ng.IPromise<BrandDTOPageableListResult> {
        let url_ = this.baseUrl + "/api/ims-io/brand";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetIMSBrands(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetIMSBrands(_response);
            throw _response;
        });
    }

    protected processGetIMSBrands(response: any): ng.IPromise<BrandDTOPageableListResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrandDTOPageableListResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrandDTOPageableListResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBrandsByFilter(body: IMSIOBrandByFilterQuery | undefined): ng.IPromise<ImsProductDTO[]> {
        let url_ = this.baseUrl + "/api/ims-io/market/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBrandsByFilter(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBrandsByFilter(_response);
            throw _response;
        });
    }

    protected processGetBrandsByFilter(response: any): ng.IPromise<ImsProductDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsProductDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsProductDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFileMarketAvailableProducts(body: FileMarketAvailableProductsQuery | undefined): ng.IPromise<FileMarketAvailableProductDTOPageableListResult> {
        let url_ = this.baseUrl + "/api/ims-io/market/available-products";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetFileMarketAvailableProducts(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetFileMarketAvailableProducts(_response);
            throw _response;
        });
    }

    protected processGetFileMarketAvailableProducts(response: any): ng.IPromise<FileMarketAvailableProductDTOPageableListResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMarketAvailableProductDTOPageableListResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileMarketAvailableProductDTOPageableListResult>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @return Success
     */
    getPharmacyMarkets(countryCode: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims-io/pharmacy-market?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPharmacyMarkets(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPharmacyMarkets(_response);
            throw _response;
        });
    }

    protected processGetPharmacyMarkets(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @param searchString (optional) 
     * @return Success
     */
    getMolecues(countryCode: string | undefined, searchString: string | undefined): ng.IPromise<MoleculeDTO[]> {
        let url_ = this.baseUrl + "/api/ims-io/molecule?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMolecues(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMolecues(_response);
            throw _response;
        });
    }

    protected processGetMolecues(response: any): ng.IPromise<MoleculeDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MoleculeDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MoleculeDTO[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @param searchString (optional) 
     * @return Success
     */
    getAtc3(countryCode: string | undefined, searchString: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims-io/atc3?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAtc3(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAtc3(_response);
            throw _response;
        });
    }

    protected processGetAtc3(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @param searchString (optional) 
     * @param atc3 (optional) 
     * @return Success
     */
    getAtc4(countryCode: string | undefined, searchString: string | undefined, atc3: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims-io/atc4?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (atc3 === null)
            throw new Error("The parameter 'atc3' cannot be null.");
        else if (atc3 !== undefined)
            url_ += "Atc3=" + encodeURIComponent("" + atc3) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetAtc4(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetAtc4(_response);
            throw _response;
        });
    }

    protected processGetAtc4(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @return Success
     */
    getPrescriptionMarket(countryCode: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims-io/prescription-market?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetPrescriptionMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetPrescriptionMarket(_response);
            throw _response;
        });
    }

    protected processGetPrescriptionMarket(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @return Success
     */
    getMoleculeType(countryCode: string | undefined): ng.IPromise<string[]> {
        let url_ = this.baseUrl + "/api/ims-io/molecule-type?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMoleculeType(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMoleculeType(_response);
            throw _response;
        });
    }

    protected processGetMoleculeType(response: any): ng.IPromise<string[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<string[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @param searchString (optional) 
     * @param molecules (optional) 
     * @return Success
     */
    getNfc3(countryCode: string | undefined, searchString: string | undefined, molecules: string[] | undefined): ng.IPromise<Nfc3DTO[]> {
        let url_ = this.baseUrl + "/api/ims-io/nfc3?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (searchString === null)
            throw new Error("The parameter 'searchString' cannot be null.");
        else if (searchString !== undefined)
            url_ += "SearchString=" + encodeURIComponent("" + searchString) + "&";
        if (molecules === null)
            throw new Error("The parameter 'molecules' cannot be null.");
        else if (molecules !== undefined)
            molecules && molecules.forEach(item => { url_ += "Molecules=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetNfc3(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetNfc3(_response);
            throw _response;
        });
    }

    protected processGetNfc3(response: any): ng.IPromise<Nfc3DTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Nfc3DTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<Nfc3DTO[]>(null as any);
    }

    /**
     * @param countryCode (optional) 
     * @return Success
     */
    getNewProductList(countryCode: string | undefined): ng.IPromise<BrandInMarketDTO[]> {
        let url_ = this.baseUrl + "/api/ims-io/new-products?";
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetNewProductList(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetNewProductList(_response);
            throw _response;
        });
    }

    protected processGetNewProductList(response: any): ng.IPromise<BrandInMarketDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BrandInMarketDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<BrandInMarketDTO[]>(null as any);
    }
}

export class MarketClient {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    copyMarket(id: number, body: CopyMarketDTO | undefined): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/market/{id}/clone";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCopyMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCopyMarket(_response);
            throw _response;
        });
    }

    protected processCopyMarket(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    marketIsEditable(id: number): ng.IPromise<EditabilityDTO> {
        let url_ = this.baseUrl + "/api/market/{id}/isEditable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processMarketIsEditable(_response);
        }, (_response) => {
            if (_response.status)
                return this.processMarketIsEditable(_response);
            throw _response;
        });
    }

    protected processMarketIsEditable(response: any): ng.IPromise<EditabilityDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EditabilityDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<EditabilityDTO>(null as any);
    }

    /**
     * @return Success
     */
    toggleMarketActivity(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/{id}/toggleActivity";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processToggleMarketActivity(_response);
        }, (_response) => {
            if (_response.status)
                return this.processToggleMarketActivity(_response);
            throw _response;
        });
    }

    protected processToggleMarketActivity(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMarketGrid(body: MarketGridQuery | undefined): ng.IPromise<MarketGridDTOPageableListResult> {
        let url_ = this.baseUrl + "/api/market";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMarketGrid(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMarketGrid(_response);
            throw _response;
        });
    }

    protected processGetMarketGrid(response: any): ng.IPromise<MarketGridDTOPageableListResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketGridDTOPageableListResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MarketGridDTOPageableListResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isMarketNameUnique(body: MarketUniqueNameQuery | undefined): ng.IPromise<boolean> {
        let url_ = this.baseUrl + "/api/market/unique";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processIsMarketNameUnique(_response);
        }, (_response) => {
            if (_response.status)
                return this.processIsMarketNameUnique(_response);
            throw _response;
        });
    }

    protected processIsMarketNameUnique(response: any): ng.IPromise<boolean> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeMarketProductManager(body: ChangeMarketProductManagerCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/productManager";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processChangeMarketProductManager(_response);
        }, (_response) => {
            if (_response.status)
                return this.processChangeMarketProductManager(_response);
            throw _response;
        });
    }

    protected processChangeMarketProductManager(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param dataSourceId (optional) 
     * @param budgetYear (optional) 
     * @return Success
     */
    getMyMarkets(dataSourceId: MarketType | undefined, budgetYear: number | undefined): ng.IPromise<ImsMarketDTO[]> {
        let url_ = this.baseUrl + "/api/market/my?";
        if (dataSourceId === null)
            throw new Error("The parameter 'dataSourceId' cannot be null.");
        else if (dataSourceId !== undefined)
            url_ += "DataSourceId=" + encodeURIComponent("" + dataSourceId) + "&";
        if (budgetYear === null)
            throw new Error("The parameter 'budgetYear' cannot be null.");
        else if (budgetYear !== undefined)
            url_ += "BudgetYear=" + encodeURIComponent("" + budgetYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMyMarkets(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMyMarkets(_response);
            throw _response;
        });
    }

    protected processGetMyMarkets(response: any): ng.IPromise<ImsMarketDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsMarketDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsMarketDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    removeMarket(id: number): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "DELETE",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRemoveMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRemoveMarket(_response);
            throw _response;
        });
    }

    protected processRemoveMarket(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getForecastHistoricalData(marketType: MarketType, body: InitializationDataRequestDTO | undefined): ng.IPromise<DataForForecastDTO> {
        let url_ = this.baseUrl + "/api/market/{marketType}/forecastInitialData";
        if (marketType === undefined || marketType === null)
            throw new Error("The parameter 'marketType' must be defined.");
        url_ = url_.replace("{marketType}", encodeURIComponent("" + marketType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetForecastHistoricalData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetForecastHistoricalData(_response);
            throw _response;
        });
    }

    protected processGetForecastHistoricalData(response: any): ng.IPromise<DataForForecastDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataForForecastDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<DataForForecastDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setMarketAsReadyToExport(id: number, body: boolean | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/{id}/toggleFinished";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processSetMarketAsReadyToExport(_response);
        }, (_response) => {
            if (_response.status)
                return this.processSetMarketAsReadyToExport(_response);
            throw _response;
        });
    }

    protected processSetMarketAsReadyToExport(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateMarketGroupFinish(body: ValidateMarketFinishQuery | undefined): ng.IPromise<MarketFinishValidationResult> {
        let url_ = this.baseUrl + "/api/market/validate-toggle-finish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processValidateMarketGroupFinish(_response);
        }, (_response) => {
            if (_response.status)
                return this.processValidateMarketGroupFinish(_response);
            throw _response;
        });
    }

    protected processValidateMarketGroupFinish(response: any): ng.IPromise<MarketFinishValidationResult> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketFinishValidationResult;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MarketFinishValidationResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMarketsSkus(body: SkusInMarketsQuery | undefined): ng.IPromise<{ [key: string]: MarketSkuDTO[]; }> {
        let url_ = this.baseUrl + "/api/market/markets-skus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetMarketsSkus(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetMarketsSkus(_response);
            throw _response;
        });
    }

    protected processGetMarketsSkus(response: any): ng.IPromise<{ [key: string]: MarketSkuDTO[]; }> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: MarketSkuDTO[]; };
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<{ [key: string]: MarketSkuDTO[]; }>(null as any);
    }

    /**
     * @return Success
     */
    getFileMarket(id: number): ng.IPromise<FileMarketDTO> {
        let url_ = this.baseUrl + "/api/market/file/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetFileMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetFileMarket(_response);
            throw _response;
        });
    }

    protected processGetFileMarket(response: any): ng.IPromise<FileMarketDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMarketDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<FileMarketDTO>(null as any);
    }

    /**
     * @return Success
     */
    createFileMarket(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/market/file";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateFileMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateFileMarket(_response);
            throw _response;
        });
    }

    protected processCreateFileMarket(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editFileMarket(body: EditFileMarketCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processEditFileMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processEditFileMarket(_response);
            throw _response;
        });
    }

    protected processEditFileMarket(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateMarketVolumeTemplate(body: MarketsVolumesTemplateQuery | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/file/template/market-volume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGenerateMarketVolumeTemplate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGenerateMarketVolumeTemplate(_response);
            throw _response;
        });
    }

    protected processGenerateMarketVolumeTemplate(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateSkusVolumeTemplate(body: MarketSkusVolumesTemplateQuery | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/file/template/skus-volume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGenerateSkusVolumeTemplate(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGenerateSkusVolumeTemplate(_response);
            throw _response;
        });
    }

    protected processGenerateSkusVolumeTemplate(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateMarketFiles(body: FileMarketDTO | undefined): ng.IPromise<MarketFileValidationResultsDTO> {
        let url_ = this.baseUrl + "/api/market/file/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processValidateMarketFiles(_response);
        }, (_response) => {
            if (_response.status)
                return this.processValidateMarketFiles(_response);
            throw _response;
        });
    }

    protected processValidateMarketFiles(response: any): ng.IPromise<MarketFileValidationResultsDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketFileValidationResultsDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<MarketFileValidationResultsDTO>(null as any);
    }

    /**
     * @return Success
     */
    postMarketVolumeFile(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/file/market-volume";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPostMarketVolumeFile(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPostMarketVolumeFile(_response);
            throw _response;
        });
    }

    protected processPostMarketVolumeFile(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    validateMarketVolumeFile(): ng.IPromise<{ [key: string]: MarketFileValidationResult; }> {
        let url_ = this.baseUrl + "/api/market/file/market-volume/validate";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processValidateMarketVolumeFile(_response);
        }, (_response) => {
            if (_response.status)
                return this.processValidateMarketVolumeFile(_response);
            throw _response;
        });
    }

    protected processValidateMarketVolumeFile(response: any): ng.IPromise<{ [key: string]: MarketFileValidationResult; }> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: MarketFileValidationResult; };
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<{ [key: string]: MarketFileValidationResult; }>(null as any);
    }

    /**
     * @return Success
     */
    postMarketSkuVolumeFile(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/file/sku-volume";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processPostMarketSkuVolumeFile(_response);
        }, (_response) => {
            if (_response.status)
                return this.processPostMarketSkuVolumeFile(_response);
            throw _response;
        });
    }

    protected processPostMarketSkuVolumeFile(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    validateMarketSkuVolumeFile(): ng.IPromise<{ [key: string]: MarketFileValidationResult; }> {
        let url_ = this.baseUrl + "/api/market/file/sku-volume/validate";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processValidateMarketSkuVolumeFile(_response);
        }, (_response) => {
            if (_response.status)
                return this.processValidateMarketSkuVolumeFile(_response);
            throw _response;
        });
    }

    protected processValidateMarketSkuVolumeFile(response: any): ng.IPromise<{ [key: string]: MarketFileValidationResult; }> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: MarketFileValidationResult; };
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<{ [key: string]: MarketFileValidationResult; }>(null as any);
    }

    /**
     * @return Success
     */
    triggerImsImportIsFinished(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/trigger-ims-import-is-finished";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processTriggerImsImportIsFinished(_response);
        }, (_response) => {
            if (_response.status)
                return this.processTriggerImsImportIsFinished(_response);
            throw _response;
        });
    }

    protected processTriggerImsImportIsFinished(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    recalculateRequirementsValidations(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/ims/recalculate-requirements";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processRecalculateRequirementsValidations(_response);
        }, (_response) => {
            if (_response.status)
                return this.processRecalculateRequirementsValidations(_response);
            throw _response;
        });
    }

    protected processRecalculateRequirementsValidations(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    importKamsoftMarketTypes(): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/ims/fill-kamsoft-market-types";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            transformResponse: [],
            headers: {
            }
        };

        return this.http(options_).then((_response) => {
            return this.processImportKamsoftMarketTypes(_response);
        }, (_response) => {
            if (_response.status)
                return this.processImportKamsoftMarketTypes(_response);
            throw _response;
        });
    }

    protected processImportKamsoftMarketTypes(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    createImsMarket(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/market/ims";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateImsMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateImsMarket(_response);
            throw _response;
        });
    }

    protected processCreateImsMarket(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editImsMarket(body: EditImsMarketCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/ims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processEditImsMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processEditImsMarket(_response);
            throw _response;
        });
    }

    protected processEditImsMarket(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkIMSMarketRequirements(body: IMSMarketMeetsRequirementsQuery | undefined): ng.IPromise<IMSMarketRequirementsCheckResultDTO> {
        let url_ = this.baseUrl + "/api/market/ims/requirements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCheckIMSMarketRequirements(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCheckIMSMarketRequirements(_response);
            throw _response;
        });
    }

    protected processCheckIMSMarketRequirements(response: any): ng.IPromise<IMSMarketRequirementsCheckResultDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IMSMarketRequirementsCheckResultDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<IMSMarketRequirementsCheckResultDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNewProductsInImsMarket(body: EditImsMarketNewProductsCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/ims/newProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processUpdateNewProductsInImsMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processUpdateNewProductsInImsMarket(_response);
            throw _response;
        });
    }

    protected processUpdateNewProductsInImsMarket(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getImsMarket(id: number): ng.IPromise<ImsMarketDTO> {
        let url_ = this.baseUrl + "/api/market/ims/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetImsMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetImsMarket(_response);
            throw _response;
        });
    }

    protected processGetImsMarket(response: any): ng.IPromise<ImsMarketDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsMarketDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsMarketDTO>(null as any);
    }

    /**
     * @return Success
     */
    getSkusInMarket(marketId: number): ng.IPromise<ImsProductDTO[]> {
        let url_ = this.baseUrl + "/api/market/ims/{marketId}/skus";
        if (marketId === undefined || marketId === null)
            throw new Error("The parameter 'marketId' must be defined.");
        url_ = url_.replace("{marketId}", encodeURIComponent("" + marketId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSkusInMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSkusInMarket(_response);
            throw _response;
        });
    }

    protected processGetSkusInMarket(response: any): ng.IPromise<ImsProductDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsProductDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsProductDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    createScoringCardsMarket(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/market/scoringCards";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateScoringCardsMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateScoringCardsMarket(_response);
            throw _response;
        });
    }

    protected processCreateScoringCardsMarket(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editScoringCardsMarket(body: EditScoringCardsMarketCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/scoringCards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processEditScoringCardsMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processEditScoringCardsMarket(_response);
            throw _response;
        });
    }

    protected processEditScoringCardsMarket(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getScoringCardMarket(id: number): ng.IPromise<ScoringCardMarketDTO> {
        let url_ = this.baseUrl + "/api/market/scoringCards/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetScoringCardMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetScoringCardMarket(_response);
            throw _response;
        });
    }

    protected processGetScoringCardMarket(response: any): ng.IPromise<ScoringCardMarketDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScoringCardMarketDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScoringCardMarketDTO>(null as any);
    }

    /**
     * @return Success
     */
    createScoringCardsPolandMarket(): ng.IPromise<number> {
        let url_ = this.baseUrl + "/api/market/scoringCardsPoland";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "PUT",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCreateScoringCardsPolandMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCreateScoringCardsPolandMarket(_response);
            throw _response;
        });
    }

    protected processCreateScoringCardsPolandMarket(response: any): ng.IPromise<number> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editScoringCardsPolandMarket(body: EditScoringCardsPolandMarketCommand | undefined): ng.IPromise<void> {
        let url_ = this.baseUrl + "/api/market/scoringCardsPoland";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http(options_).then((_response) => {
            return this.processEditScoringCardsPolandMarket(_response);
        }, (_response) => {
            if (_response.status)
                return this.processEditScoringCardsPolandMarket(_response);
            throw _response;
        });
    }

    protected processEditScoringCardsPolandMarket(response: any): ng.IPromise<void> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            return this.q.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getScoringCardMarketPoland(id: number): ng.IPromise<ScoringCardPolandMarketDTO> {
        let url_ = this.baseUrl + "/api/market/scoringCardsPoland/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetScoringCardMarketPoland(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetScoringCardMarketPoland(_response);
            throw _response;
        });
    }

    protected processGetScoringCardMarketPoland(response: any): ng.IPromise<ScoringCardPolandMarketDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScoringCardPolandMarketDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScoringCardPolandMarketDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkScoringCardsPolandMarketRequirements(body: ScoringCardsPolandMarketMeetsRequirementsQuery | undefined): ng.IPromise<ScoringCardsPolandMarketRequirementsCheckResultDTO> {
        let url_ = this.baseUrl + "/api/market/scoringCardsPoland/requirements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCheckScoringCardsPolandMarketRequirements(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCheckScoringCardsPolandMarketRequirements(_response);
            throw _response;
        });
    }

    protected processCheckScoringCardsPolandMarketRequirements(response: any): ng.IPromise<ScoringCardsPolandMarketRequirementsCheckResultDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScoringCardsPolandMarketRequirementsCheckResultDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScoringCardsPolandMarketRequirementsCheckResultDTO>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMarketRequirements(body: MarketsMeetsRequirementsQuery | undefined): ng.IPromise<number[]> {
        let url_ = this.baseUrl + "/api/market/check-requirements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processCheckMarketRequirements(_response);
        }, (_response) => {
            if (_response.status)
                return this.processCheckMarketRequirements(_response);
            throw _response;
        });
    }

    protected processCheckMarketRequirements(response: any): ng.IPromise<number[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<number[]>(null as any);
    }

    /**
     * @return Success
     */
    getSimilarNeeds(): ng.IPromise<SimilarNeedsDefinitionDTO[]> {
        let url_ = this.baseUrl + "/api/market/similarNeeds";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSimilarNeeds(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSimilarNeeds(_response);
            throw _response;
        });
    }

    protected processGetSimilarNeeds(response: any): ng.IPromise<SimilarNeedsDefinitionDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarNeedsDefinitionDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<SimilarNeedsDefinitionDTO[]>(null as any);
    }
}

export class ScoringCardsClient {
    private baseUrl: string | undefined = undefined;
    private http: ng.IHttpService;
    private q: ng.IQService;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor($http: ng.IHttpService, $q: ng.IQService, baseUrl?: string) {
        this.http = $http;
        this.q = $q;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param marketType (optional) 
     * @return Success
     */
    getProjects(marketType: ProjectCardMarketType | undefined): ng.IPromise<ProjectDTO[]> {
        let url_ = this.baseUrl + "/api/scoring-cards/project?";
        if (marketType === null)
            throw new Error("The parameter 'marketType' cannot be null.");
        else if (marketType !== undefined)
            url_ += "marketType=" + encodeURIComponent("" + marketType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetProjects(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetProjects(_response);
            throw _response;
        });
    }

    protected processGetProjects(response: any): ng.IPromise<ProjectDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getProjectData(uid: string): ng.IPromise<ProjectDataDTO> {
        let url_ = this.baseUrl + "/api/scoring-cards/project/{uid}";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetProjectData(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetProjectData(_response);
            throw _response;
        });
    }

    protected processGetProjectData(response: any): ng.IPromise<ProjectDataDTO> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDataDTO;
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectDataDTO>(null as any);
    }

    /**
     * @return Success
     */
    getProjectFilters(uid: string): ng.IPromise<ProjectFilterDTO[]> {
        let url_ = this.baseUrl + "/api/scoring-cards/project/{uid}/filters";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetProjectFilters(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetProjectFilters(_response);
            throw _response;
        });
    }

    protected processGetProjectFilters(response: any): ng.IPromise<ProjectFilterDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectFilterDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ProjectFilterDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getSummary(): ng.IPromise<ScoringCardSummaryDTO[]> {
        let url_ = this.baseUrl + "/api/scoring-cards/summary";
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetSummary(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetSummary(_response);
            throw _response;
        });
    }

    protected processGetSummary(response: any): ng.IPromise<ScoringCardSummaryDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScoringCardSummaryDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScoringCardSummaryDTO[]>(null as any);
    }

    /**
     * @return Success
     */
    getReport(budgetVersionUId: string): ng.IPromise<ScoringCardReportItemDTO[]> {
        let url_ = this.baseUrl + "/api/scoring-cards/report/{budgetVersionUId}";
        if (budgetVersionUId === undefined || budgetVersionUId === null)
            throw new Error("The parameter 'budgetVersionUId' must be defined.");
        url_ = url_.replace("{budgetVersionUId}", encodeURIComponent("" + budgetVersionUId));
        url_ = url_.replace(/[?&]$/, "");

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "GET",
            transformResponse: [],
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetReport(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetReport(_response);
            throw _response;
        });
    }

    protected processGetReport(response: any): ng.IPromise<ScoringCardReportItemDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScoringCardReportItemDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ScoringCardReportItemDTO[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBrandsByFilter(body: ScoringCardsBrandByFilterQuery | undefined): ng.IPromise<ImsProductDTO[]> {
        let url_ = this.baseUrl + "/api/scoring-cards/market/filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        var options_: ng.IRequestConfig = {
            url: url_,
            method: "POST",
            data: content_,
            transformResponse: [],
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http(options_).then((_response) => {
            return this.processGetBrandsByFilter(_response);
        }, (_response) => {
            if (_response.status)
                return this.processGetBrandsByFilter(_response);
            throw _response;
        });
    }

    protected processGetBrandsByFilter(response: any): ng.IPromise<ImsProductDTO[]> {
        const status = response.status;

        let _headers: any = {};
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImsProductDTO[];
            return this.q.resolve(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException(this.q, "An unexpected server error occurred.", status, _responseText, _headers);
        }
        return this.q.resolve<ImsProductDTO[]>(null as any);
    }
}

export interface Assumptions {
    benchmark: string;
    marketInfoMore: string;
    moleculeInfoMore: string;
    newProduct: string;
    newProductCompetitors: string;
    otherComments: string;
    priceAssets: string;
    priceAssetsCompetitors: string;
    productInfoMore: string;
    promotionalForces: string;
    promotionalForcesCompetitors: string;
    refundactionAssumptions: string;
    risks: RiskEntry[];
}

export interface AssumptionsExportDTO {
    assumptions: Assumptions;
    metadata: AssumptionsMetadata;
}

export interface AssumptionsMetadata {
    brand: string;
    forecast: string;
    molecule: string;
    market: string;
}

export interface AveragePriceInYearDTO {
    averagePrice: number;
    year: number;
}

export interface Brand {
    assumptions: Assumptions;
    customData: CustomData;
    externalIds: number[];
    forecast: BrandForecast;
    molecules: string[];
    name: string;
    scProjectName: string;
    scTradeTerms: YearValue[];
    scMarketingBudgets: YearValue[];
    skus: Sku[];
}

export interface BrandByFilterQuery {
    filters: MarketFilterDTO[] | null;
}

export interface BrandDTO {
    id: number;
    brand: string;
    company: string;
    market: string;
    readonly molecules: string[];
    skus: SKUDTO[];
}

export interface BrandDTOPageableListResult {
    items: BrandDTO[];
    totalCount: number;
}

export interface BrandForecast {
    dot: ForecastHolder;
    historicalDotData: number[];
    historicalMksh: number[];
    historicalValueData: number[];
    historicalVolumeData: number[];
    mkshr: number[];
    value: ForecastHolder;
    volume: ForecastHolder;
}

export interface BrandGroupHistoricalDataDTO {
    brandExternalIds: number[];
    historicalData: BrandMkshrResultDTO;
    yearlyForecast: YearForecastDTO[];
    skus: BrandInitializationDataResult[];
}

export interface BrandGroupNameDTO {
    id: number | null;
    name: string;
}

export interface BrandInMarketDTO {
    name: string;
    company: string;
    externalId: number | null;
    skuCount: number;
    skus: SkuDTO[];
    molecules: string[];
    owner: string;
    hasOracleIndex: boolean;
    hasSkusOwnedByMe: boolean;
    scProjectName: string;
    scTradeTerms: YearValueDTO[];
    scMarketingBudgets: YearValueDTO[];
}

export interface BrandInitializationDataResult {
    oracleCode: string;
    skuIDs: number[];
    data: DataResultDTO;
    yearlyForecast: YearForecastDTO[];
    exFactoryHistoricalData: ExFactoryValueDTO;
    rotation: number | null;
    itemsInStock: number | null;
    sales: number | null;
    itemsInStockDate: Date | null;
    salesTo: Date | null;
    salesFrom: Date | null;
    launchDate: Date | null;
}

export interface BrandMkshrResultDTO {
    mkshr: number[];
    volume: number[];
    dot: number[];
    value: number[];
}

export interface BrandQuery {
    page: number;
    pageSize: number;
    pharmacyMarket: string | null;
    atc3: string | null;
    atc4: string | null;
    nfc3: string[] | null;
    brand: string | null;
    perscirptionMarket: string | null;
    moleculeType: string | null;
    molecules: string[] | null;
    skipSkusIds: number[] | null;
    sortField: string | null;
    sortType: string | null;
    sku: string | null;
    onlySelectedMolecues: boolean;
}

export interface BudgetVersionDTO {
    id: number;
    name: string;
    comment: string;
    budgetYear: number;
    versionId: string;
    isEditable: boolean;
    isMainVersion: boolean;
}

export interface BudgetVersionDashboardDTO {
    versionUId: string;
    name: string;
    budgetYear: number;
    status: string;
    comment: string;
    creationTimeInPandL: Date;
    createdByInPandL: string;
    createdByInPandLFullName: string;
    createdFrom: BudgetVersionDTO;
    modificationTime: Date | null;
    markedForExport: boolean;
    forecastStatisticApprovedCount: number;
    forecastStatisticAwaitingBUMApprovalCount: number;
    forecastStatisticReturnedToCorrection: number;
    productCodeStatisticApprovedCount: number;
    productCodeStatisticAwaitingBUMApprovalCount: number;
    productCodeStatisticReturnedToCorrection: number;
}

export interface CalculateExFactoryRequestDTO {
    historicalDataStart: Date;
    forecastStartDate: Date;
    skus: SkuExFactoryDTO[];
}

export interface ChangeForecastProductManagerCommand {
    forecastId: number;
    productManagerMsnuId: string;
}

export interface ChangeMarketProductManagerCommand {
    marketId: number;
    productManagerMsnuId: string;
}

export interface ChangeOracleIndexCommand {
    changes: ChangeProductCodeInForecastDTO[];
}

export interface ChangeProductCodeDTO {
    oldProductCode: string;
    newProductCode: string;
}

export interface ChangeProductCodeInForecastDTO {
    forecastId: number;
    oldProductCode: string;
    newProductCode: string;
}

export interface CommentWrapper {
    comment: string | null;
}

export interface CopyMarketDTO {
    name: string | null;
    version: string | null;
    budgetYear: number | null;
}

export interface CorrectForecastAfterDefenceCommand {
    forecastId: number;
    comment: string;
    jsonData: ForecastData;
}

export interface Correction {
    desc: string;
    direction: number;
    endDate: Date;
    impact: number;
    name: string;
    risk: number | null;
    startDate: Date;
    absoluteValue: number | null;
    impactType: ImpactTypeEnum;
}

export interface CountryDTO {
    code: string;
    name: string;
    currencyCode: string;
}

export interface CreatedForecastGridDTO {
    id: number;
    name: string;
    productManager: string;
    productManagerByMsnuId: string;
    modificationTime: string;
    marketName: string;
    marketId: string;
    marketType: string;
    assignedPerson: string;
    status: string;
    creationTime: string;
    assignedPersonMsnuId: string;
    supervisor: string;
    businessUnitManagerMsnuId: string;
    hasCorrectionAfterDefece: boolean;
    isDelisted: boolean;
    marketVersion: string;
    hasForecastMarketDump: boolean;
    marketCountry: string;
    isEditable: boolean;
}

export interface CreatedForecastGridDTOPageableListResult {
    items: CreatedForecastGridDTO[];
    totalCount: number;
}

export interface CustomData {
    values: Values;
    isDelisted: boolean;
}

export interface DataForForecastDTO {
    imsImportDate: Date;
    imsDataTo: Date;
    market: DataResultDTO;
    marketForecast: DataResultDTO;
    marketAveragePrice: AveragePriceInYearDTO[];
    priceChangeInYears: number[];
    brandGroups: BrandGroupHistoricalDataDTO[];
}

export interface DataResultDTO {
    dot: number[];
    volume: number[];
    value: number[];
}

export interface DataSource {
    name: string;
    urlPart: string;
}

export enum DbConnection {
    AMLDB = "AMLDB",
    AMLExportDB = "AMLExportDB",
    DomainDB = "DomainDB",
    PandLDB = "PandLDB",
}

export interface EditFileMarketCommand {
    market: FileMarketDTO;
}

export interface EditImsMarketCommand {
    market: ImsMarketDTO;
}

export interface EditImsMarketNewProductsCommand {
    marketId: number;
    productCodes: string[];
}

export interface EditScoringCardsMarketCommand {
    market: ScoringCardMarketDTO;
}

export interface EditScoringCardsPolandMarketCommand {
    market: ScoringCardPolandMarketDTO;
}

export interface EditabilityDTO {
    readonly isActivable: boolean;
    isCloneable: boolean;
    isEditable: boolean;
}

export enum ExFactoryAlgorithmType {
    ExFactorySlidingWindowCalculator = "ExFactorySlidingWindowCalculator",
    ExFactorySimpleCalculator = "ExFactorySimpleCalculator",
}

export interface ExFactoryValueDTO {
    value: number[];
    volume: number[];
}

export interface FileIdentifier {
    userName: string | null;
    fileUri: string | null;
}

export interface FileMarketAvailableProductDTO {
    id: number;
    productCode: string;
    sku: string;
    brand: string;
    line: string;
    market: string;
    region: string;
    businessUnit: string;
}

export interface FileMarketAvailableProductDTOPageableListResult {
    items: FileMarketAvailableProductDTO[];
    totalCount: number;
}

export interface FileMarketAvailableProductsQuery {
    filters: MarketFilterDTO[] | null;
    countryCode: string | null;
    excludedProductCodes: string[] | null;
}

export interface FileMarketDTO {
    id: number;
    name: string;
    description: string;
    isCreatedByMy: boolean;
    historicalDataStart: Date | null;
    historicalDataEnd: Date | null;
    historicalVolumeExists: boolean;
    isHistoricalVolumeValid: boolean;
    skuHistoricalVolumeExists: boolean;
    isSkuHistoricalVolumeValid: boolean;
    products: ProductPlannerAssignmentDTO[];
    countryCode: string;
    currencyCode: string;
    budgetYear: number | null;
    skuHistoricalVolumeDataSource: SkuHistoricalVolumeDataSourceType;
    historicalVolumeDataSource: HistoricalVolumeDataSourceType;
    filters: MarketFilterDTO[];
    newProductsOracleIndex: string[];
}

export enum FilterType {
    Include = "Include",
    Exclude = "Exclude",
}

export enum FilterTypeEnum {
    ShowAssignedToGivenPlanner = "ShowAssignedToGivenPlanner",
    ShowAssignedToAnyPlanner = "ShowAssignedToAnyPlanner",
    ShowNotAssignedToPlanner = "ShowNotAssignedToPlanner",
    ShowExpectProductCodesAndNotAssgined = "ShowExpectProductCodesAndNotAssgined",
    ShowWithNoForecastAssignedToGivenPlannerExpectProductCodes = "ShowWithNoForecastAssignedToGivenPlannerExpectProductCodes",
    ShowAll = "ShowAll",
    ShowAllWithNoForecastExpectProductCodes = "ShowAllWithNoForecastExpectProductCodes",
    ShowExcludedFromForecasting = "ShowExcludedFromForecasting",
    ShowIncludeProductCodesOnly = "ShowIncludeProductCodesOnly",
}

export interface ForecastDTO {
    id: number;
    uId: string;
    name: string | null;
    status: string | null;
    supervisor: string | null;
    modificationDate: Date | null;
    correctionComment: string | null;
    isEditable: boolean;
    isEditableAsApproved: boolean;
    isDelisted: boolean;
    readonly creationTime: Date | null;
    readonly hasCorrectionAfterDefece: boolean;
    readonly isBudgetVersionEditable: boolean;
    readonly budgetVersionName: string | null;
    readonly budgetVersionBudgetYear: number | null;
    readonly budgetVersionComment: string | null;
    readonly canEditCombinedConditions: boolean;
    jsonData: ForecastData;
}

export interface ForecastData {
    imsDataTimestamp: Date;
    imtDataToMonth: Date;
    market: Market;
    parameters: Parameters;
    version: number;
}

export interface ForecastGridDTO {
    id: number;
    name: string;
    productManager: string;
    productManagerByMsnuId: string;
    modificationTime: string;
    marketName: string;
    marketId: string;
    marketType: string;
    marketVersion: string;
    hasForecastMarketDump: boolean;
    creationTime: string;
    marketCountry: string;
    forecastStartDate: Date | null;
}

export interface ForecastGridDTOPageableListResult {
    items: ForecastGridDTO[];
    totalCount: number;
}

export interface ForecastHistoryDTO {
    type: string;
    user: string;
    creationTime: string;
}

export interface ForecastHolder {
    pmForecast: number[];
    statisticalForecast: number[];
}

export interface ForecastMarketDumpDTO {
    marketName: string | null;
    version: string | null;
    description: string | null;
    marketId: number;
    dumpCreationTime: string | null;
    countryCode: string | null;
    currencyCode: string | null;
    forecastId: number;
    hasSkuInForecastDump: boolean;
    newProducts: OracleIndex[] | null;
}

export interface ForecastMetadataDTO {
    id: number;
    uId: string;
    name: string | null;
    status: string | null;
    supervisor: string | null;
    modificationDate: Date | null;
    correctionComment: string | null;
    isEditable: boolean;
    isEditableAsApproved: boolean;
    isDelisted: boolean;
    readonly creationTime: Date | null;
    readonly hasCorrectionAfterDefece: boolean;
    readonly isBudgetVersionEditable: boolean;
    readonly budgetVersionName: string | null;
    readonly budgetVersionBudgetYear: number | null;
    readonly budgetVersionComment: string | null;
    readonly canEditCombinedConditions: boolean;
}

export enum ForecastMethod {
    Sku = "sku",
    Mktsh = "mktsh",
    Chamfering = "chamfering",
}

export interface ForecastMethodEntry {
    methodId: ForecastMethod;
    name: string;
}

export interface ForecastProductCodesDTO {
    forecastId: number;
    forecastName: string;
    forecastStatus: string;
    forecastStartYear: number;
    oldProductCode: string;
    newProductCode: string;
}

export interface ForecastProductCodesQuery {
    productCodes: ChangeProductCodeDTO[] | null;
    forecastYear: number | null;
    forecastStatus: ForecastStatus;
}

export interface ForecastSimpleSearchDTO {
    id: number;
    name: string;
}

export enum ForecastStatus {
    Draft = "Draft",
    AwaitingBUMApproval = "AwaitingBUMApproval",
    ReturnedToCorrection = "ReturnedToCorrection",
    Approved = "Approved",
}

export enum ForecastType {
    Value = "Value",
    Volume = "Volume",
    DOT = "DOT",
}

export interface ForecastTypeEntry {
    name: string;
    typeId: ForecastTypeId;
}

export enum ForecastTypeId {
    Value = "value",
    Volume = "volume",
    Dot = "dot",
}

export enum HistoricalVolumeDataSourceType {
    File = "File",
    ImsIO = "ImsIO",
}

export interface IMSIOBrandByFilterQuery {
    filters: MarketFilterDTO[] | null;
    countryCode: string | null;
}

export interface IMSIOBrandQuery {
    page: number;
    pageSize: number;
    pharmacyMarket: string | null;
    atc3: string | null;
    atc4: string | null;
    nfc3: string[] | null;
    brand: string | null;
    perscirptionMarket: string | null;
    moleculeType: string | null;
    molecules: string[] | null;
    skipSkusIds: number[] | null;
    sortField: string | null;
    sortType: string | null;
    sku: string | null;
    onlySelectedMolecues: boolean;
    countryCode: string | null;
}

export interface IMSMarketMeetsRequirementsQuery {
    filters: MarketFilterDTO[] | null;
    kamsoftMarketType: string | null;
}

export interface IMSMarketRequirementsCheckResultDTO {
    hasTwoCompetitors: boolean;
    hasAdamedProducts: boolean;
    satisfiesMarketType: boolean;
    hasErrors: boolean;
}

export enum ImpactTypeEnum {
    Percentage = "percentage",
    Absolute = "absolute",
    Explicit = "explicit",
}

export interface ImsLatestImportDateDTO {
    importDate: Date;
    dataTo: Date;
}

export interface ImsMarketDTO {
    id: number;
    uId: string;
    name: string;
    version: string;
    description: string;
    budgetYear: number | null;
    kamsoftMarketType: string;
    similarNeeds: string;
    marketDefinition: MarketDefinitionDTO;
    hasSkuInMarketDefinition: boolean;
    filters: MarketFilterDTO[];
    newProductsOracleIndex: string[];
    historicalDataStart: Date | null;
    historicalDataEnd: Date | null;
    isCreatedByMy: boolean;
    countryCode: string;
    currencyCode: string;
    isMarketFinished: boolean;
}

export interface ImsNewProductsQuery {
}

export interface ImsProductDTO {
    id: number;
    brandId: number | null;
    brand: string;
    company: string;
    perscirptionMarket: string;
    manufacturer: string;
    dose: string;
    readonly molecules: string[];
    moleculesString: string;
    moleculeType: string;
    productId: number | null;
    sku: string;
    bloz: number | null;
    atcOtc1: string;
    atcOtc2: string;
    atcOtc3: string;
    atcOtc4: string;
    nfc1: string;
    nfc2: string;
    nfc3: string;
    pharmacyMarket: string;
    productCode: string;
}

export interface InitializationBrandGroup {
    brandExternalIds: number[];
    skus: InitializationSku[];
}

export interface InitializationDataRequestDTO {
    forecastId: number;
    marketId: number;
    forecastType: ForecastType;
    historicalDataStartMonth: Date;
    historicalDataEndMonth: Date;
    forecastStartMonth: Date;
    forecastEndMonth: Date;
    brandGroups: InitializationBrandGroup[];
}

export interface InitializationSku {
    skuExternalIds: number[];
    oracleIndex: string;
}

export interface InitializeForecastCommand {
    forecastId: number;
    name: string;
    jsonData: ForecastData;
}

export interface JsonNode {
    options: JsonNodeOptions;
    parent: JsonNode;
    root: JsonNode;
}

export interface JsonNodeOptions {
    propertyNameCaseInsensitive: boolean;
}

export interface LastHistoricalDataDateDTO {
    year: number;
    month: number;
    productId: number;
}

export interface LastHistoricalDataDateQuery {
    marketId: number;
    skuIds: number[] | null;
}

export interface MLOracleIndexDataDTO {
    oracleIndex: string;
    businessUnit: string;
    line: string;
    region: string;
    market: string;
    productGroup: string;
    abcGroup: string;
    sku: string;
    brand: string;
    bloz: number | null;
}

export interface MachineLearningDTO {
    machineLearningGuid: string;
}

export interface MachineLearningData {
    modelId: string;
    monthNumberForAverage: number;
    calculationIsReady: boolean;
}

export interface Market {
    brands: Brand[];
    forecast: MarketForecast;
    id: number;
    uId: string;
    name: string;
    version: string;
    countryCode: string;
    currencyCode: string;
}

export interface MarketBrandDTO {
    name: string;
}

export interface MarketContentQuery {
    year: number;
    status: MarketContentReportType;
}

export enum MarketContentReportType {
    All = "All",
    ForecastUsedInAcceptedMarkets = "ForecastUsedInAcceptedMarkets",
    FinishedMarket = "FinishedMarket",
}

export interface MarketDefinitionDTO {
    id: number | null;
    name: string;
    brand: string;
    identifier: number;
    products: ProductDictionaryDTO[];
    isActive: boolean;
}

export interface MarketFileValidationResult {
    readonly fieldsErrors: ValidationEntry[];
    readonly productsErrors: ValidationEntry[];
    marketName: string;
    readonly hasErrors: boolean;
}

export interface MarketFileValidationResultsDTO {
    isProductsFileValid: boolean;
}

export interface MarketFilterDTO {
    type: FilterType;
    atc3: string;
    atc4: string;
    nfc3: string[];
    brand: string;
    pharmacyMarket: string;
    perscirptionMarket: string;
    molecules: string[];
    moleculeType: string;
    sku: string;
    onlySelectedMolecues: boolean;
}

export interface MarketFinishValidationResult {
    multipleNamesToFinishViolation: MarketWithTheSameNameDTO[] | null;
    marketWithSameNamesAlreadyFinish: MarketSimpleDTO[] | null;
    marketWithoutBudgetYear: MarketSimpleDTO[] | null;
    marketNotMetRequirements: MarketSimpleDTO[] | null;
    readonly isValid: boolean;
}

export interface MarketForecast {
    correction: Correction[];
    dataAfterCorrection: number[];
    dataAfterSkipped: number[];
    dataAfterSmoothing: number[];
    historicalData: number[];
    historicalValueData: number[];
    period: number;
    pmForecast: number[];
    priceChangeInYears: number[];
    regression: string;
    regressionRFactor: number | null;
    regressionMapeFactor: number | null;
    regressionWholePeriod: number[];
    skippedEnd: number;
    skippedStart: number;
    statisticalForecast: number[];
    value: ForecastHolder;
    yearlyAveragePrice: YearlyAveragePrice[];
    machineLearningData: MachineLearningData[];
    freezedMonths: number | null;
    freezedMonthsVolume: number[];
    freezedMonthForecast: number[];
}

export interface MarketGridDTO {
    creationTime: Date | null;
    description: string;
    editabilityInfo: EditabilityDTO;
    id: number;
    name: string;
    marketDefinitionName: string;
    version: string;
    productManager: string;
    productManagerMsnuId: string;
    isActive: boolean | null;
    type: string;
    isFinished: boolean;
    budgetYear: number | null;
    skuHistoricalVolumeDataSource: SkuHistoricalVolumeDataSourceType;
    historicalVolumeDataSource: HistoricalVolumeDataSourceType;
}

export interface MarketGridDTOPageableListResult {
    items: MarketGridDTO[];
    totalCount: number;
}

export interface MarketGridQuery {
    page: number;
    pageSize: number;
    productManager: string | null;
    name: string | null;
    description: string | null;
    type: MarketType[] | null;
    sortField: string | null;
    sortType: string | null;
    budgetYear: number | null;
}

export interface MarketIOSkusValueQuery {
    filters: MarketFilterDTO[] | null;
    startMonth: Date;
    endMonth: Date;
    currency: string | null;
    countryCode: string | null;
}

export interface MarketIOValueQuery {
    filters: MarketFilterDTO[] | null;
    startMonth: Date;
    endMonth: Date;
    currency: string | null;
    countryCode: string | null;
}

export interface MarketSimpleDTO {
    id: number;
    name: string;
    version: string;
    description: string;
    budgetYear: number | null;
    type: string;
}

export interface MarketSkuDTO {
    productCode: string;
    sku: string;
    brand: string;
}

export interface MarketSkuVolumeFileGenerationDTO {
    marketId: number;
    marketName: string;
    skus: MarketSkuDTO[];
    skuHistoricalVolumeDataSource: SkuHistoricalVolumeDataSourceType;
}

export interface MarketSkusValueQuery {
    filters: MarketFilterDTO[] | null;
    startMonth: Date;
    endMonth: Date;
}

export interface MarketSkusVolumesTemplateQuery {
    markets: MarketSkuVolumeFileGenerationDTO[] | null;
    historicalDataStart: Date | null;
    historicalDataEnd: Date | null;
}

export enum MarketType {
    Ims = "Ims",
    File = "File",
    ScoringCards = "ScoringCards",
    ScoringCardsPoland = "ScoringCardsPoland",
}

export interface MarketUniqueNameQuery {
    marketName: string | null;
    version: string | null;
    budgetYear: number | null;
    marketId: number;
}

export interface MarketValueQuery {
    filters: MarketFilterDTO[] | null;
    startMonth: Date;
    endMonth: Date;
}

export interface MarketVolumeFileGenerationDTO {
    marketId: number;
    marketName: string;
    historicalVolumeDataSource: HistoricalVolumeDataSourceType;
}

export interface MarketWithTheSameNameDTO {
    budgetYear: number;
    name: string | null;
    versions: string[] | null;
    marketIds: number[] | null;
}

export interface MarketsMeetsRequirementsQuery {
    marketIds: number[] | null;
}

export interface MarketsVolumesTemplateQuery {
    markets: MarketVolumeFileGenerationDTO[] | null;
    historicalDataStart: Date | null;
    historicalDataEnd: Date | null;
}

export interface ModelIdentifier {
    modelId: string | null;
}

export interface MoleculeDTO {
    name: string;
}

export interface Nfc3DTO {
    name: string;
    fullName: string;
}

export interface NotificationRecipientsRequest {
    notificationType: string | null;
    context: string | null;
}

export interface OracleIndex {
    oracleIndex: string;
    businessUnit: string;
    line: string;
    region: string;
    market: string;
    productGroup: string;
    aBCGroup: string;
    sku: string;
    brand: string;
}

export interface Parameters {
    dataSource: DataSource;
    forecastEndDate: Date;
    forecastMethod: ForecastMethodEntry;
    forecastStartDate: Date;
    forecastType: ForecastTypeEntry;
    historicalDataEnd: Date;
    historicalDataStart: Date;
    marketBudgetYear: number | null;
}

export interface PeriodConfigDTO {
    historicalDataDurationInYears: number;
    forecastDurationInYears: number;
    forecastStartDate: Date;
}

export interface PharmInTotalIMSShareQuery {
    productCodes: string[] | null;
    startDate: Date;
    endDate: Date;
}

export enum PharmacyMarket {
    PHARM = "PHARM",
    HOSP = "HOSP",
}

export interface PlannerProductSearchOptions {
    brand: string | null;
    sku: string | null;
    oracleIndex: string | null;
    market: string | null;
    line: string | null;
    region: string | null;
    businessUnit: string | null;
    sortField: string | null;
    sortType: string | null;
    page: number;
    pageSize: number;
    plannerId: string | null;
    budgetVersionUId: string | null;
    includeAssignedPlannerColumn: boolean;
    includeApproverColumn: boolean;
    expectProductCodes: string[] | null;
    includeProductCodes: string[] | null;
    filterType: FilterTypeEnum;
}

export interface ProductDictionaryDTO {
    id: number;
    name: string;
}

export interface ProductPlannerAssignmentDTO {
    id: number;
    productCode: string;
    sku: string;
    brand: string;
    line: string;
    market: string;
    region: string;
    businessUnit: string;
    plannerName: string;
    plannerId: string;
}

export interface ProductPriceDTO {
    productCode: string;
    price: number;
}

export interface ProductWithAssignmentsDTO {
    id: number;
    productCode: string;
    sku: string;
    brand: string;
    line: string;
    market: string;
    region: string;
    businessUnit: string;
    ownerName: string;
    approverName: string;
    businessUnitManagerName: string;
    directorName: string;
    isActive: boolean | null;
}

export interface ProductWithAssignmentsDTOPageableListResult {
    items: ProductWithAssignmentsDTO[];
    totalCount: number;
}

export interface ProductWithOwnerAndApproverDTO {
    sku: string | null;
    brand: string | null;
    productCode: string | null;
    country: string | null;
    owner: string | null;
    approver: string | null;
    businessUnitManager: string | null;
    director: string | null;
}

export enum ProjectCardMarketType {
    International = "International",
    Poland = "Poland",
}

export interface ProjectDTO {
    uId: string;
    name: string;
    countryCode: string;
    currencyCode: string;
    createdByName: string;
    createdByEmail: string;
    launchDate: Date;
}

export interface ProjectDataDTO {
    id: number;
    projectUId: string;
    projectForecast: ProjectYearlyForecastDTO[];
    skus: ProjectSkuDTO[];
    forecastStartDate: Date;
    forecastEndDate: Date;
}

export interface ProjectFilterDTO {
    countryCode: string;
    imsName: string;
    molecule: string;
    moleculeAll: string;
    manufacturer: string;
    company: string;
    rxOtc: string;
    monoCombo: string;
    pharmacyMarket: string;
    doses: string;
    atcOtc1: string;
    atcOtc2: string;
    atcOtc3: string;
    atcOtc4: string;
    nfc1: string;
    nfc2: string;
    nfc3: string;
    brands: string;
}

export interface ProjectSkuDTO {
    projectCode: string;
    name: string;
}

export interface ProjectYearlyForecastDTO {
    year: number;
    volume: number;
    averagePrice: number;
}

export interface RegressionDTO {
    method: RegressionMethod;
    x: number[];
    y: number[];
    xPred: number[];
    startingMonthNo: number;
}

export enum RegressionMethod {
    Periodical_linear = "periodical_linear",
    Periodical_logarithmic = "periodical_logarithmic",
    Linear = "linear",
    Logarithmic = "logarithmic",
    Machine_learning = "machine_learning",
}

export interface RiskConfigDTO {
    id: number | null;
    name: string;
    value: number;
    isActive: boolean;
}

export interface RiskConfigDTOPageableListResult {
    items: RiskConfigDTO[];
    totalCount: number;
}

export interface RiskDTO {
    id: number;
    name: string;
    value: number;
}

export interface RiskEntry {
    date: Date;
    risk: string;
}

export interface RollingForecastVolumeDTO {
    productCode: string;
    volume: number[];
}

export interface SKUDTO {
    id: number;
    sku: string;
    pharmacyMarket: string;
    atcOtc3: string;
    atcOtc4: string;
    nfc3: string;
    oracleIndex: string;
    owner: string;
}

export interface ScoringCardMarketDTO {
    id: number;
    name: string;
    version: string;
    description: string;
    budgetYear: number | null;
    marketForecast: number[];
    project: ProjectDTO;
    forecastStartDate: Date | null;
    forecastEndDate: Date | null;
    priceChangeInYears: number[];
    yearlyAveragePrice: ProjectYearlyForecastDTO[];
}

export interface ScoringCardPolandMarketDTO {
    id: number;
    name: string;
    version: string;
    description: string;
    marketForecast: number[];
    project: ProjectDTO;
    forecastStartDate: Date | null;
    forecastEndDate: Date | null;
    budgetYear: number | null;
    marketDefinition: MarketDefinitionDTO;
    isCreatedByMy: boolean;
    countryCode: string;
    currencyCode: string;
    isMarketFinished: boolean;
    kamsoftMarketType: string;
    similarNeeds: string;
    filters: ProjectFilterDTO[];
    priceChangeInYears: number[];
    yearlyAveragePrice: ProjectYearlyForecastDTO[];
}

export interface ScoringCardReportForecastItem {
    forecastId: number;
    forecastName: string;
    forecastStatus: string;
}

export interface ScoringCardReportItemDTO {
    scoringCardId: string;
    scoringCardName: string;
    hasMarketCreated: boolean;
    marketName: string | null;
    marketId: number | null;
    marketType: MarketType;
    forecasts: ScoringCardReportForecastItem[];
}

export interface ScoringCardSummaryDTO {
    creationTime: Date;
    createdBy: string;
    projectName: string;
    currencyCode: string;
    countryCode: string;
    forecastDateFrom: Date;
    forecastDateTo: Date;
    skuName: string;
    productCode: string;
}

export interface ScoringCardsBrandByFilterQuery {
    filters: ProjectFilterDTO[] | null;
}

export interface ScoringCardsPolandMarketMeetsRequirementsQuery {
    filters: ProjectFilterDTO[] | null;
    kamsoftMarketType: string | null;
}

export interface ScoringCardsPolandMarketRequirementsCheckResultDTO {
    satisfiesMarketType: boolean;
    hasErrors: boolean;
}

export interface SendToApprovalCommand {
    forecastId: number;
    force: boolean;
    budgetVersionUId: string;
}

export interface SimilarNeedsDefinitionDTO {
    id: number;
    name: string | null;
}

export interface Sku {
    dddFact: number | null;
    externalId: number | null;
    newProductId: string;
    forecast: { [key: string]: JsonNode; };
    name: string;
    oracleIndex: string;
    pharmacyMarket: PharmacyMarket;
    scSkuName: string;
    scDiscounts: YearValue[];
    scCOGs: YearValue[];
}

export interface SkuDTO {
    id: number;
    name: string;
    pharmacyMarket: string;
    externalId: number | null;
    oracleIndex: string;
    canBeForecast: boolean;
    owner: string;
    molecule: string;
    dddFact: number | null;
    bloz: number | null;
    scSkuName: string;
    scDiscounts: YearValueDTO[];
    sccoGs: YearValueDTO[];
}

export interface SkuExFactoryDTO {
    historicalData: ExFactoryValueDTO;
    forecast: number[];
    freezedMonthsVolume: number[];
    launchDate: Date | null;
    rotation: number | null;
    itemsInStock: number | null;
    itemsInStockDate: Date | null;
    sales: number | null;
    salesFrom: Date | null;
    salesTo: Date | null;
    dddFactor: number | null;
    unit: ForecastType;
    oracleCode: string;
    algorithmType: ExFactoryAlgorithmType;
}

export enum SkuHistoricalVolumeDataSourceType {
    File = "File",
    Vmi = "Vmi",
}

export interface SkusInMarketsQuery {
    marketIds: number[] | null;
}

export enum SourceEnum {
    Name = "Name",
    Description = "Description",
}

export interface SubstitutionValuesRequest {
    entity: any | null;
    userId: string | null;
    requestedTags: TemplateTag[] | null;
    notificationType: string | null;
}

export interface TLRollingForecastManySkusQuery {
    forecastStartDate: Date;
    forecastEndDate: Date;
    productCodes: string[] | null;
}

export interface TableExportDTO {
    columns: string[];
    rows: TableRowDTO[];
}

export interface TableRowDTO {
    header: string;
    decimalPlaces: number | null;
    isPercentage: boolean | null;
    values: string[];
}

export interface TemplateTag {
    key: string | null;
    value: string | null;
}

export interface UpdateForecastNameDTO {
    name: string | null;
}

export interface UserDTO {
    msnuId: string;
    fullName: string;
}

export interface VMIDataDTO {
    rotation: number;
    itemsInStock: number;
    itemsInStockDate: Date;
    salesFrom: Date;
    salesTo: Date;
    sales: number;
}

export interface VMIOracleIndexDataDTO {
    oracleIndex: string;
    vmi: VMIDataDTO;
}

export interface ValidateMarketFinishQuery {
    marketIds: number[] | null;
}

export interface ValidationEntry {
    path: string;
    productCode: string;
    resultType: ValidationResultType;
}

export enum ValidationResultType {
    MissingData = "MissingData",
    ExpectedDifferentValue = "ExpectedDifferentValue",
    MissingPermission = "MissingPermission",
}

export interface Values {
    customValues: number[];
    labels: number[];
    originalValues: number[];
}

export interface YearForecastDTO {
    year: number;
    volume: number | null;
    volumeMkshr: number | null;
    price: number | null;
    value: number | null;
}

export interface YearValue {
    year: number;
    value: number | null;
}

export interface YearValueDTO {
    year: number;
    value: number | null;
}

export interface YearlyAveragePrice {
    averagePrice: number;
    year: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(q: ng.IQService, message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): ng.IPromise<any> {
    if (result !== null && result !== undefined)
        return q.reject(result);
    else
        return q.reject(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: Blob, q: ng.IQService): ng.IPromise<string> {
    return new q((resolve) => {
        let reader = new FileReader();
        reader.onload = event => resolve((event.target as any).result);
        reader.readAsText(blob);
    });
}

}